import React from "react";
import { OmniDropdownComponent, OmniIconComponent, OmniTableComponent, OmniTooltipNextComponent, LoaderComponent, OmniTableStickyComponent, InlineEditDialogBox, exportStatusHtml, AlertMessagesService, tableUtils as TableUtils, Utils, MediaOpsService, trackEvent } from "../../../../shared";
import { Om2Dropdown, om2confirm } from "omni-campaign-ui";
import { html } from "lit";
import { CampaignDetailService } from "../../";
import { PlacementDetailsTableService, PlacementUtils } from "../../../placements";
import { OverAllBudgetComponent } from "./overallBudgetInCampaignDetailsComponent";
import ChildCampaignModal from "./childCampaignModal";
import TaxonomySyncModal from "./taxonomySyncModal";
import { querySelectorDeep } from "omni-ui";
import CampaignTaxonomySyncPopup from "./campaignTaxonomySyncPopup";

export class CampaignDetailComponent extends React.Component {
  partnersDropdownOptions = [];
  previousOpendPopUpIndex = null
  isOnlineSwitchOn = true;
  isPrintSwitchOn = true;
  previousOpendPopUpIndexInTaxonomySyncModal = null;
  isInlineOverride = false;

  constructor(props) {
    super(props);    
    Om2Dropdown.register();
    this.state = {
      sort: {
        key: "name",
        dir: "asc",
      },
      channelsData: this.mediaData(
        props?.state?.campaignObj?.channels ? props.state.campaignObj.channels : []
      ),
      endDate: '',
      startDate: '',
      enableSelectButton: false,
      isCreateChildCampaign: props.isCreateChildCampaign || false,
      isChildCampaignModalOpen: false,
      mediaSelectAll: false,
      displayOnlineAccordionContent: "none",
      displayPrintAccordionContent: "none",
      taxonomyName: "",
      taxonomyNameWithAbbrevation: "",
      taxonomySchema: "",
      needsUpdateBtnText: "Needs Update",
      campaignObj: props?.state?.campaignObj,
      syntheticId: "-",
      clientCodes:[],
      onlineArr : [],
      printArr : [],
      clientCode:'',
      selectedDDValue:{
        name:'',
        value:null
      },
      editCampaignTaxonomy:false,
      displayChildCampaignPreview: false,
      childCampaignPreview: {},
      isChildCampaignCreated: false,
      enableSelectChannelButton: false,
      totalInOverallBudget: props?.state?.totalInOverallBudget,
      editChildCampaign: false,
      parentCampaign: {},
      parentCampaignOnlineArr: [],
      parentCampaignPrintArr: [],
      parentTotalInOverallBudget: '',
      childCampaignStartDate: '',
      childCampaignEndDate: '',
      displayChildCampaignTotalErrorMessage: false,
      mediaopsCampaignTaxonomy: props?.state?.campaignObj?.campaign_taxonomy?.split(':|')[0],
      planitCampaignTaxonomy: '',
      mediaOceanCampaignTaxonomy: '',
      taxonomySyncErrorMessage: '',
      displayTaxonomySyncModal: false,
      taxonomySyncDataArray: [],
      selectedTaxonomyFromSync: '',
      syncTaxonomiesWithHighlights: '',
      spinnerCount: 0,
      popupVisible: false,
      popupProps: null,
      popupPosition: { top: 0, left: 0 },
      taxonomySchemaArray :{},
      isShowModal : false
    };
    // commented code in this file is required in future after we make the planit changes to the parent campaign
    // parentCampaign: props?.location?.state?.parentCampaign,

    this.campaignChildItems = props?.state?.campaignObj?.nestedData ? props.state.campaignObj.nestedData : [];
    this.campaignChildPublisherList = {};
    this.createPartnersDropdownOptions();
    // Bind the method to the class instance
    this.updateTotalInOverallBudget = this.updateTotalInOverallBudget.bind(this);    
  }

  componentDidMount() { 
    if((!this.props.isCreateChildCampaign && !this.props.displayPreview) || !this.state?.campaignObj?.campaign_name) {      
      this.getCampaignData(true, false, false);
    } else {
      this.processCampaignData(this.state?.campaignObj, false, false);
    }
    if(this.props?.state?.campaignObj?.exportStatus === 'Needs Update'){
      this.setState({needsUpdateBtnText: 'Confirm Update'});
    }    
  }

  /** 
   * The above code is a JavaScript function called `updateCampaignNameAndSyntheticId`. It checks if the
   * `campaignObj` property of the current state has a non-empty `campaignTaxonomy` property. If it does,
   * it sets the `taxonomyName` property of the state to the first part of the `campaignTaxonomy` string
   * (before the `:|` separator). If `campaignTaxonomy` is empty or undefined, it calls the
   * `genrateCampaignTaxonomyName` function to generate a new taxonomy name. Then, it calls the
   * `updateSyntheticId` function and sets 
   */
  updateCampaignNameAndSyntheticId = () => {
    this.genrateCampaignTaxonomyName(true);
    // For child creation, generate the new name with current taxonomy schema and the parent taxonomy data. 
    if(this.props.isCreateChildCampaign){
      let editFormData = this.getCampaignEditData();
      let {updatedName, updatedDisplayName, schema, taxonomyJson} = this.getUpdatedNameAndSchema(editFormData);
      let campaignObj = { ...this.state.campaignObj };
      campaignObj.campaignTaxonomy = updatedName;
      campaignObj.campaign_taxonomy = updatedName;
      campaignObj.campaign_taxonomy_display = updatedDisplayName;
      campaignObj.taxonomy = taxonomyJson;
      campaignObj.taxonomy_schema = schema;
      this.setState({
        taxonomyName: updatedName,
        mediaopsCampaignTaxonomy: updatedName,
        taxonomyNameWithAbbrevation: updatedDisplayName,
        taxonomySchema: schema,
        taxonomyJson: taxonomyJson,
        campaignObj: campaignObj
      });
    } else if (this.state?.campaignObj?.campaignTaxonomy?.split(':|')[0] !== "-"  && this.state.campaignObj?.campaignTaxonomy?.split(':|')[0]) {
      this.setState({ 
        taxonomyName: this.state.campaignObj?.campaignTaxonomy?.split(':|')[0],
        mediaopsCampaignTaxonomy: this.state.campaignObj?.campaignTaxonomy?.split(':|')[0],
        taxonomyNameWithAbbrevation: this.state.campaignObj['campaign_taxonomy_display'],
        taxonomySchema: this.state.campaignObj['taxonomy_schema']
      });
    } else {
      this.genrateCampaignTaxonomyName(false);
    }
    this.updateSyntheticId();
  }

  /**
   * get campaign data based with the campaign id and client id in query param
   * and update the campaign obj, syntheicid and channels in state
   */
  getCampaignData = (loadChildCampaign = true, reloadCampaignData = false, isSendToMediaOcean = false) => {
    this.props.setSpinnerCount(1);
    let campaignId = this.state?.campaignObj?.id ? encodeURIComponent(this.state?.campaignObj?.id) : this.props?.params?.campaignId;
    MediaOpsService.getCampaignDataById(campaignId, this.state?.campaignObj?.client_id, this.props?.versionOneApi)
      .then((campaignData) => {
        let campainObj = campaignData.length ? campaignData[0] : this.state.campaignObj;
        // setting the child local currency, since child GET call doesn't fetch local currency.
        if (this.state?.campaignObj?.parent_id && this.state?.campaignObj?.local_currency_name) {
          campainObj.local_currency_name = this.state.campaignObj.local_currency_name;
        }
        this.processCampaignData(campainObj, loadChildCampaign, isSendToMediaOcean);
      })
      .catch((error) => {
        this.props.setSpinnerCount(0);
        AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: () => this.getCampaignData(loadChildCampaign), title: 'Unable to load the campaign details API', bodyMsgArr: [] }]);
      });
  }


  /**
   * Processes campaign data and updates the component's state and props.
   * @param {Object} campaignObj - The campaign data object.
   * @param {boolean} loadChildCampaign - Whether to load child campaigns.
   * @memberof CampaignComponent
   */
  processCampaignData = (campaignObj, loadChildCampaign, isSendToMediaOcean) => {
    this.props.setCampaignName(Utils.formatCampaignTitle(campaignObj));
    this.setState({
      onlineArr: [],
      campaignObj: CampaignDetailService.updateCampaignDataObj(campaignObj),
      channelsData: this.mediaData(campaignObj?.channels ? campaignObj.channels : [], isSendToMediaOcean),
      spinnerCount: 0
    }, () => {
      this.updateCampaignNameAndSyntheticId();
      this.createTablesData(loadChildCampaign);
      this.getClientCode();
      this.getParentCampaign();
      this.props.navigate({}, { replace: true, state: { campaignObj: campaignObj, parentCampaign: this.props?.location?.state?.parentCampaign } });
    });
  }

  /** The below code is a JavaScript function called `createTablesData`. It filters an array of
   * `channelsData` objects and separates them into two arrays: `onlineArr` and `printArr`. 
   * remove ad verification and Ad serving data if toggle fees is on
   * budget, adVerification, adServing and MObudget value is assign according to row and column
   */
  createTablesData = (loadChildCampaign) =>{    
    this.state.channelsData.forEach((obj) => {
      obj.name = obj.channel_name;
      obj.displayName = obj.channel_display_name;
      obj.budget = obj.channel_total_budget;
      obj.budgetLocal = obj.channel_total_budget_local;
      obj.authorized_amount = obj.channel_authorized_amount;
      obj.publisher_type = 'channel';
      let totalFeeBudget = null;
      let totalMOBudget = null;
      let totalFeeBudgetLocal = null;
      obj.startDate = obj.channel_startdate;
      obj.endDate = obj.channel_enddate;

      obj.publishers.forEach(pubObj => {
        // check for MO campaign and assign budget and nested data
        if (pubObj.isMOChild) {
          let childPubObj = this.campaignChildPublisherList[pubObj.campaignId];
          pubObj.nestedData = childPubObj && childPubObj[pubObj.channelName] ? childPubObj[pubObj.channelName].publishers : [];
          pubObj.MObudget = childPubObj && childPubObj[pubObj.channelName] ? childPubObj[pubObj.channelName].total : 0;
          totalMOBudget = totalMOBudget ? totalMOBudget + pubObj.MObudget : pubObj.MObudget;
        } else {
          pubObj.name = pubObj.publisher_name;
          pubObj.displayName = pubObj.publisher_display_name;
          pubObj.adVerifactionBudget = '';
          pubObj.adServingBudget = '';
          pubObj.budget = pubObj.publisher_budget;
          pubObj.budgetLocal = pubObj.publisher_budget_local;
          pubObj.MObudget = '';
          pubObj.startDate = pubObj?.publisher_start_date;
          pubObj.endDate = pubObj?.publisher_end_date;
          if(pubObj?.publisher_type !== "Supplier"){
            pubObj.budget = '';
            pubObj.budgetLocal = '';
            pubObj.publisher_budget && (pubObj.totalFeeAmount = pubObj.publisher_budget);
            pubObj.publisher_budget_local && (pubObj.totalFeeAmountLocal = pubObj.publisher_budget_local);
            pubObj.publisher_budget && (totalFeeBudget += pubObj.publisher_budget);
            pubObj.publisher_budget_local && (totalFeeBudgetLocal += pubObj.publisher_budget_local);
          }
          pubObj.authorized_amount =   pubObj.publisher_authorized_amount;
        }
        pubObj.export_status = '';
        pubObj.channel_name = obj.channel_name;
        pubObj.channel_display_name = obj.channel_display_name;
      });

      // get total of ad verification, ad serving & MO budget
      obj.MObudget = totalMOBudget ? totalMOBudget : '';
      obj.totalFeeAmount = totalFeeBudget;
      obj.totalFeeAmountLocal = totalFeeBudgetLocal;
      obj.nestedData = obj.publishers;
      obj._uniqueKey = obj.channel_name;
      // total budget column 2, it's total of net media ,ad verification and ad serving total
      obj.totalBudget = Number(totalFeeBudget) + Number(obj.channel_total_budget);      
      obj.totalBudgetLocal = Number(totalFeeBudgetLocal) + Number(obj.channel_total_budget_local);      
    });

    const onlineArr = this.state.channelsData.filter( obj =>  obj?.channel_name?.toLowerCase() !== "print")
    const printArr = this.state.channelsData.filter( obj =>  obj?.channel_name?.toLowerCase() === "print")
    if(!this.isOnlineSwitchOn){
      onlineArr.map((val)=>{
        let nestedData =  val.nestedData.filter( obj =>  obj?.publisher_type === "Supplier");
        val.nestedData = nestedData;
        val.totalBudget = val.totalBudget - val.totalFeeAmount;        
        val.totalFeeAmount = 0;
     });
    }
    if(!this.isPrintSwitchOn){
      printArr.map((val)=>{
        let nestedData =  val.nestedData.filter( obj =>  obj?.publisher_type === "Supplier");
        val.nestedData = nestedData;
        val.totalBudget = val.totalBudget - val.totalFeeAmount;
        val.totalFeeAmount = 0;
     });
    }
    this.setState({printArr, onlineArr}, ()=>{
      // logic to expand only the parent rows on load
      let expandRows = [];
      for(let i=0;i<onlineArr.length;i++){
        expandRows.push(onlineArr[i]);
      }
      
    })
  }

  /**
   * Fetches the parent campaign data if the parent campaign ID is available in the location state.
   * 
   * This method checks if the parent campaign ID is present in the location state. If it is, it fetches the campaign data
   * using the MediaOpsService and updates the component state with the prepared campaign data. Once the state is updated,
   * it calls the createParentCampaignTableData method to process the data further.
   * 
   */
  getParentCampaign() {
    if (this.props?.parentCampaignObj?.id === this.state?.campaignObj?.parent_id) {
      this.setState({
        parentCampaign: this.props?.parentCampaignObj, 
        childCampaignStartDate: this.state?.campaignObj?.startDate,
        childCampaignEndDate: this.state?.campaignObj?.endDate
      }, () => {
        this.createParentCampaignTableData();
        this.genrateCampaignTaxonomyName(true);
      });
    } else if (this.props?.location?.state?.parentCampaign?.id || this.state?.campaignObj?.parent_id) {
      this.setState({spinnerCount: 1});
      let parentId = encodeURIComponent(this.props?.location?.state?.parentCampaign?.id || this.state?.campaignObj?.parent_id);
      MediaOpsService.getCampaignDataById(
        parentId,
        this.props?.location?.state?.parentCampaign?.client_id || this.state?.campaignObj?.client_id, 
        this.props?.versionOneApi).then((parentCampaign) => {      
        this.setState({
          parentCampaign: MediaOpsService.prepareCampaignData(parentCampaign)[0], 
          childCampaignStartDate: this.state?.campaignObj?.startDate,
          childCampaignEndDate: this.state?.campaignObj?.endDate
        }, () => {
          this.createParentCampaignTableData();
          this.genrateCampaignTaxonomyName(true);
          this.props.setParentCampaignObj(this.state.parentCampaign);
        });
      }, (error) => {
        AlertMessagesService.showErrorToastMessage(`Unable to get the latest parent campaign data: ${error}`);
      }).finally(() => {
        this.setState({spinnerCount: 0});
      })
    }
  }

  /**
   * Processes and prepares the parent campaign data for display in the table.
   * 
   * This method processes the parent campaign data by iterating over the channels and publishers,
   * calculating various budget values, and organizing the data into a format suitable for display
   * in the table. It then updates the component state with the processed data.
   * 
   */
    createParentCampaignTableData = () => {
    if (this.state.parentCampaign) {
      const parentCampaign = { ...this.state.parentCampaign };
      parentCampaign.channelsData = this.mediaData(parentCampaign?.channels ? parentCampaign.channels : []);
      parentCampaign.channelsData.forEach((obj, channelIndex) => {
        obj.name = obj.channel_name;
        obj.displayName = obj.channel_display_name;
        obj.budget = obj.channel_total_budget;
        obj.budgetLocal = obj.channel_total_budget_local;
        obj.authorized_amount = obj.channel_authorized_amount;
        obj.publisher_type = 'channel';
        let totalFeeBudget = null;
        let totalMOBudget = null;
        let totalFeeBudgetLocal = null;
        obj.startDate = obj.channel_startdate;
        obj.endDate = obj.channel_enddate;

        obj.publishers.forEach(pubObj => {
          // check for MO campaign and assign budget and nested data
          if (pubObj.isMOChild) {
            let childPubObj = this.campaignChildPublisherList[pubObj.campaignId];
            pubObj.nestedData = childPubObj && childPubObj[pubObj.channelName] ? childPubObj[pubObj.channelName].publishers : [];
            pubObj.MObudget = childPubObj && childPubObj[pubObj.channelName] ? childPubObj[pubObj.channelName].total : 0;
            totalMOBudget = totalMOBudget ? totalMOBudget + pubObj.MObudget : pubObj.MObudget;
          } else {
            pubObj.name = pubObj.publisher_name;
            pubObj.displayName = pubObj.publisher_display_name;
            pubObj.adVerifactionBudget = '';
            pubObj.adServingBudget = '';
            pubObj.budget = pubObj.publisher_budget;
            pubObj.budgetLocal = pubObj.publisher_budget_local;
            pubObj.MObudget = '';
            pubObj.startDate = pubObj?.publisher_start_date;
            pubObj.endDate = pubObj?.publisher_end_date;
            if (pubObj?.publisher_type !== "Supplier") {
              pubObj.budget = '';
              pubObj.budgetLocal = '';
              pubObj.publisher_budget && (pubObj.totalFeeAmount = pubObj.publisher_budget);
              pubObj.publisher_budget_local && (pubObj.totalFeeAmountLocal = pubObj.publisher_budget_local);
              pubObj.publisher_budget && (totalFeeBudget += pubObj.publisher_budget);
              pubObj.publisher_budget_local && (totalFeeBudgetLocal += pubObj.publisher_budget_local);
            }
            pubObj.authorized_amount = pubObj.publisher_authorized_amount;
          }
          pubObj.export_status = '';
        });

        // get total of ad verification, ad serving & MO budget
        obj.MObudget = totalMOBudget ? totalMOBudget : '';
        obj.totalFeeAmount = totalFeeBudget;
        obj.totalFeeAmountLocal = totalFeeBudgetLocal;
        obj.nestedData = obj.publishers;
        obj._uniqueKey = obj.channel_name;
        // total budget column 2, it's total of net media ,ad verification and ad serving total
        obj.totalBudget = Number(totalFeeBudget) + Number(obj.channel_total_budget);
        obj.totalBudgetLocal = Number(totalFeeBudgetLocal) + Number(obj.channel_total_budget_local);
      });

      const parentCampaignOnlineArr = parentCampaign.channelsData.filter(obj => obj?.channel_name?.toLowerCase() !== "print")
      const parentCampaignPrintArr = parentCampaign.channelsData.filter(obj => obj?.channel_name?.toLowerCase() === "print")
      this.setState({ parentCampaignOnlineArr, parentCampaignPrintArr, parentCampaign }, () => {
        this.updateParentCampaignOnlineAndPrintArr(this.state.onlineArr, this.state.printArr);
      })
    }
  }

  /**
   * Processes and prepares the parent campaign data for display in the table.
   * 
   * This method processes the parent campaign data by iterating over the channels and publishers,
   * calculating various budget values, and organizing the data into a format suitable for display
   * in the table. It then updates the component state with the processed data.
   * 
   */
  updateParentCampaignOnlineAndPrintArr(onlineArr, printArr) {
    const updateArray = (arr, parentArr) => {
      const arrCopy = [...arr];
      const parentArrCopy = [...this.state[parentArr]];

      // Create a map for parent objects keyed by channel_name
      const parentObjMap = new Map();
      parentArrCopy.forEach(parentObj => {
        parentObjMap.set(parentObj.channel_name, parentObj);
        parentObj['checked'] = 'none'; // Initialize checked to 'none'
        parentObj.nestedData.forEach(parentPubObj => {
          parentPubObj['checked'] = 'none'; // Initialize checked to 'none'
        });
      });

      // Iterate over arrCopy and update parent objects
      arrCopy.forEach(obj => {
        const parentObj = parentObjMap.get(obj.channel_name);
        if (parentObj) {
          parentObj['checked'] = 'all';
          parentObj['budgetLocal'] = obj['budgetLocal'];
          parentObj['budget'] = obj['budget'];
          parentObj['channel_total_budget'] = obj['channel_total_budget'];
          parentObj['channel_total_budget_local'] = obj['channel_total_budget_local'];
          parentObj['endDate'] = obj['endDate'];
          parentObj['startDate'] = obj['startDate'];

          // Create a map for parent nested data keyed by publisher_name
          const parentPubObjMap = new Map();
          parentObj.nestedData.forEach(parentPubObj => {
            parentPubObjMap.set(parentPubObj.publisher_name, parentPubObj);
          });

          // Update nested data
          obj.nestedData.forEach(pubObj => {
            const parentPubObj = parentPubObjMap.get(pubObj.publisher_name);
            if (parentPubObj) {
              parentPubObj['checked'] = 'all';
              parentPubObj['budgetLocal'] = pubObj['budgetLocal'];
              parentPubObj['budget'] = pubObj['budget'];
              parentPubObj['endDate'] = pubObj['endDate'];
              parentPubObj['startDate'] = pubObj['startDate'];
              parentPubObj['publisher_budget'] = pubObj['publisher_budget'];
              parentPubObj['publisher_budget_local'] = pubObj['publisher_budget_local'];
              parentPubObj['publisher_start_date'] = pubObj['publisher_start_date'];
              parentPubObj['publisher_end_date'] = pubObj['publisher_end_date'];
            }
          });
        }
      });

      this.setState({ [parentArr]: parentArrCopy }, () => {
        this.updateParentCampaignTotalInOverallBudget();
      });

    };

    updateArray(onlineArr, 'parentCampaignOnlineArr');
    updateArray(printArr, 'parentCampaignPrintArr');

  }

  /**
   * Updates the total budget for the parent campaign in the overall budget.
   * 
   * This method calculates the total budget for the parent campaign by combining the online and print arrays.
   * It uses the `CampaignDetailService.updateBudgetTableData` method to update the budget table data and then
   * transforms the amounts using the `Utils.transformAmounts` method. Finally, it updates the component state
   * with the calculated total budget.
   * 
   */
  updateParentCampaignTotalInOverallBudget() {
    let parentTotalInOverallBudget = CampaignDetailService.updateBudgetTableData(
      this.state.parentCampaignOnlineArr,
      this.state.parentCampaignPrintArr,
      this.props?.systemParametersData?.data?.isLocal,
      this.state?.campaignObj?.local_currency_name || this.props?.campaignObj?.local_currency_name)
    parentTotalInOverallBudget = Utils.transformAmounts(parentTotalInOverallBudget);
    this.setState({ parentTotalInOverallBudget });
  }
  
  /**
   * Generates the campaign taxonomy name, taxonomy name with abbreviation, and taxonomy schema.
   *
   * This function iterates over the fields in the campaign taxonomy data and constructs the campaign taxonomy name,
   * taxonomy name with abbreviation, and taxonomy schema based on the field type and values in the campaign object.
   * The generated values are then set in the component's state.
   *
   * @param {boolean} [setPlanetTaxonomy=false] - Flag indicating whether to set the planet taxonomy.
   * @returns {void}
   */
  genrateCampaignTaxonomyName(setPlanetTaxonomy = false) {
    let campaignTaxonomyName = "", camapaignTaxonomyNameWithAbbrevation = "", taxonomySchema = "";
    let campaignObj = this.state.campaignObj;
    let taxonomyJson = [];
    if (setPlanetTaxonomy && this.state.campaignObj?.parent_id && this.state?.parentCampaign?.id) {
      campaignObj = this.state.parentCampaign;
    } else {
      campaignObj = this.state.campaignObj;
    }

    this.props.campaignTaxonomyData && this.props.campaignTaxonomyData.fields.forEach((field, index) => {
      let taxonomyField = {
          code: "NU",
          delimiter: field['delimiter_value'],
          id: field['id'] || null
      }
      if (field?.name?.toLowerCase() === 'channel') {
        if (campaignObj['channels'].length > 1) {
          campaignTaxonomyName += 'MUL' + field['delimiter_value'];
          camapaignTaxonomyNameWithAbbrevation += 'MUL' + field['delimiter_value'];
          taxonomyField.code ='MUL';
        } else if (campaignObj['channels'].length === 1) {
          campaignTaxonomyName += campaignObj['channels'][0]['channel_name'] || "NU";
          campaignTaxonomyName += field['delimiter_value'];
          camapaignTaxonomyNameWithAbbrevation += campaignObj['channels'][0]['channel_name'] || " ";
          camapaignTaxonomyNameWithAbbrevation += field['delimiter_value'];
          taxonomyField.code = campaignObj['channels'][0]['channel_name'] || "NU";
        } else {
          campaignTaxonomyName += "NU" + field['delimiter_value'];
          camapaignTaxonomyNameWithAbbrevation += " " + field['delimiter_value'];
        }
        taxonomySchema += "Channel" + '|';
      } else {
        /* field_type =1 for Dropdown field
          field_type=2 for FreeText field
          field_type= 9 for Static Text
        */

        switch (field.field_type) {
          case 1:
            let fieldCodeValue, fieldName = "";
            fieldCodeValue = field.fielditems.filter(fielditem => fielditem['name'] === campaignObj[field?.name?.toLowerCase()]).map((fielditem) => {
              fieldName = fielditem.name || "";
              return fielditem.code;
            })
            campaignTaxonomyName += (fieldCodeValue[0] || "NU") + field['delimiter_value']
            camapaignTaxonomyNameWithAbbrevation += fieldName + field['delimiter_value']
            taxonomyField.code = fieldCodeValue[0] || 'NU';
            break;
          case 2:
            campaignTaxonomyName += (campaignObj[field?.name?.toLowerCase()] || "NU") + field['delimiter_value']
            camapaignTaxonomyNameWithAbbrevation += campaignObj[field?.name?.toLowerCase()] + field['delimiter_value']
            taxonomyField.code = campaignObj[field?.name?.toLowerCase()] || "NU";
            break;
          case 9:
            campaignTaxonomyName += field.static_field_value + field['delimiter_value']
            camapaignTaxonomyNameWithAbbrevation += field.static_field_value + field['delimiter_value']
            taxonomyField.code = field.static_field_value;
            break;
          case 10:
             campaignTaxonomyName += (campaignObj[field?.name?.toLowerCase()] || "{TaxonomyValueID}") + field['delimiter_value']
            camapaignTaxonomyNameWithAbbrevation += campaignObj[field?.name?.toLowerCase()] + field['delimiter_value']
            taxonomyField.code = campaignObj[field?.name?.toLowerCase()] || "{TaxonomyValueID}";
            break;
          default:
            campaignTaxonomyName += (campaignObj[field?.name?.toLowerCase()] || "NU") + field['delimiter_value']
            camapaignTaxonomyNameWithAbbrevation += campaignObj[field?.name?.toLowerCase()] + field['delimiter_value']
             taxonomyField.code = campaignObj[field?.name?.toLowerCase()] || "NU";
            break;
        }
        taxonomySchema += field["name"] + '|';
      }

      taxonomyJson.push(taxonomyField);
      if (index === this.props.campaignTaxonomyData.fields.length - 1) {
        if (setPlanetTaxonomy) {
          this.setState({ planitCampaignTaxonomy: campaignTaxonomyName.slice(0, -1), planitCampaignSchema: taxonomySchema.slice(0, -1),planitTaxonomyJson : taxonomyJson }, () => { this.generateMediaOceanCampaignTaxonomy() });
        } else {
          this.setState({
            taxonomyName: campaignTaxonomyName.slice(0, -1),
            taxonomyNameWithAbbrevation: camapaignTaxonomyNameWithAbbrevation.slice(0, -1),
            taxonomySchema: taxonomySchema.slice(0, -1)
          }); 
        }
      }
    });
  }

  /** 
   * The above code is defining an arrow function called `updateSyntheticId`. This function checks if the
   * `campaignObj` property exists in the `state` object and if its `campaignTaxonomy` property is not
   * equal to "-". If both conditions are true, it sets the `syntheticId` property in the `state` object
   * to the second element of the array returned by splitting the `campaignTaxonomy` string using the
   * `':|'` separator. 
   */
  updateSyntheticId = () => {
    if (this.state?.campaignObj?.synthetic_id && this.state?.campaignObj?.synthetic_id !== "-") {
      this.setState({ syntheticId: this.state.campaignObj?.synthetic_id });
    }
  }

  mediaData = (mediaRow, isSendToMediaOcean=false) => {
    return (
      mediaRow &&
      mediaRow.map((ele) => {
        //we are ignoring other tech from publisher
        let publishers = ele?.publishers?.filter(val=> val.publisher_type !=="Other Fees");
        ele.publishers = publishers;
        const checked = (isSendToMediaOcean && ele?.export_status === 'Campaign Sent') ? true : false;
        return { ...ele, checked };
      })
    );
  };

  createPartnersDropdownOptions = () => {
    this.state.channelsData.map((media) => {
      return this.partnersDropdownOptions.push({
        label: media["partner"],
        value: media["partner"],
      });
    });
  };

  gotoCampaignTable = () => {
    this.props.navigate("/");
  };

  /**;
   * Function genrate campaign detail form where all field will be disabled except client Id drop down.
   * @returns Campaign detail form HTML 
   */
  getCampaignDetailsSection() {
    return (
      <div className="campaign-details-container">
        <div className="campaign-details-section">
          <div className="input-container omni-ui-adjust-width client-id">
            <label htmlFor="clientId">Client Code</label>
            <OmniDropdownComponent
            typeahead
            key='clientId'
            searchindropdown
            fieldtype="client"
            fieldname = "clientId"
            options={this.state.clientCodes}
            value={[this.state.clientCode]}
            onDropdownChange={(event) => this.onDropdownChange(event)}
            placeholder="Select Client Code"
            hidefooter={true}
            disabled={this.state.campaignObj.exportStatus=== 'Campaign Sent'?true:null}
            />
            <div className="dropdown-wrapper" >
            </div>
          </div>
          <div className="input-container">
            <label htmlFor="campaignStartDate">Campaign/Flight start date</label>
            {this.state.isCreateChildCampaign ? 
              <input type="date" id="start-date" name="startDate" className="input start-date-input"
                onChange={this.handleDate}
                value={this.state.startDate}
                data-date={this.getDate(this.state.startDate ? this.state.startDate : this.state?.campaignObj?.startDate) || "Enter Start Date"}
                min={this.state.campaignObj['startDate']}
                max={this.state.campaignObj['endDate']} />
              :
              <div className="date-field">
                <span id="campaignStartDate" className="text is-small">{Utils.formatDateObject(this.state.campaignObj.startDate)}</span>
              </div>
            }
          </div>
          <div className="input-container">
            <label htmlFor="campaignEndDate">Campaign/Flight end date</label>
            {this.state.isCreateChildCampaign ? 
              <input type="date" id="end-date" name="endDate" className="input end-date-input"
                value={this.state.endDate}
                onChange={this.handleDate}
                data-date={this.getDate(this.state.endDate ? this.state.endDate : this.state?.campaignObj?.endDate) || "Enter End Date"}
                min={this.state.startDate || this.state.campaignObj['startDate']}
                max={this.state.campaignObj['endDate']} />
              :
              <div className="date-field">
                <span id="campaignStartDate" className="text is-small">{Utils.formatDateObject(this.state.campaignObj.endDate)}</span>
              </div>
            }
          </div>

          {this.state?.campaignObj?.mediaocean_id &&
            <div className="input-container">
              <label htmlFor="campaignEndDate">Mediaocean Id</label>
              <div className="date-field">
                <span id="campaignStartDate" className="text is-small">{this.state.campaignObj.mediaocean_id}</span>
              </div>
            </div>
          }

        </div>
        {this.state.isCreateChildCampaign && <button disabled={this.state.enableSelectButton} className="medium" onClick={() => this.setState({ isChildCampaignModalOpen: true })}>Select channels</button>}
      </div>
    );
  }

   /**
   * On change of client drop down function will call update campaign function 
   * And set drop down value,
   * @param {object} event drop down selected value in event
   */
    onDropdownChange = (event) => {
      if (!this.state.isCreateChildCampaign) {
        if (event?.detail && (event?.detail !== this.state.clientCode)) {
          let payload = {};
          //if synthetic_id(external_id) is not available in campain then if condtilon will add campaign detail to genrate synthetic_id 
          if(!this.state.campaignObj.external_id){
            payload = MediaOpsService.prepareCampaignDataForClientCode(this.state.campaignObj,this.state.taxonomyName,this.state.taxonomyNameWithAbbrevation,this.state.taxonomySchema);
          }
          payload.clientCode = event.detail;
          payload.campaignStartDate = this.state.campaignObj?.startDate;
          payload.campaignEndDate = this.state.campaignObj?.endDate;
          this.updateCampaign(payload);
        }
      } else {
        this.setState({clientCode:event?.detail });
      }
    };
  
  /**
   * Handles the update of sorting for a specific table (online or print).
   * Updates the sorted table data in the component state accordingly.
   * @param {Event} event - The event that triggered the sorting update.
   * @returns {void}
   */
  onSortUpdate = (event) => {
    let targetTable = event.target.id;
    let tableData = event.detail.data;
    const key = event.detail.sort.key;
    const dir = event.detail.sort.dir;
    let updatedData = CampaignDetailService.sortTableData(tableData,key,dir);
    if (targetTable === "online-table") {
      this.setState({onlineArr:updatedData, sort: { key, dir }});
    } else {
      this.setState({printArr:updatedData, sort: { key, dir }});
    }
  };

  /**
   * TO find checkboxes that are selected
   * @param {string} rootId checkbox id
   * @param {string} id table id
   * @returns select checkbox html DOM
   */
  getElementById = (rootId, id, isModal) =>{
    const table = document.getElementById(rootId).shadowRoot;
    return isModal ? table.getElementById(id) : table.getElementById('left-table').shadowRoot.getElementById(id);
  }

  //on selection of select all checkbox in Media mix table
  selectAllChannels = (media, isModal, event) => {
    let checked = event.target.checked;
    let updatedData;
    updatedData = [...this.state.channelsData].map((ele, index) => {
      if (
        media === "print"
          ? ele.channel_name === "Print"
          : ele.channel_name !== "Print"
      ) {
        const checkbox = this.getElementById(
          `${media}-table`,
          `${media}-${ele.id || ele.channel_name}-${index}`,
          isModal
        );
        if (checkbox) checkbox.checked = checked; // assign checkbox checked value to element
        return { ...ele, checked: checked }; // update checkbox checked value to row object
      }
      return ele;
    });
    this.setState({
      channelsData: updatedData,
      mediaSelectAll: checked,
    });
  };

  //on selection of checkbox in Media mix table
  handleCheckboxChange = (value, index, media, isModal, event) => {
    const tableShadowRoot = document.getElementById(`${media}-table`).shadowRoot;
    const shadowRootContent = isModal ? tableShadowRoot : tableShadowRoot.getElementById(`left-table`)?.shadowRoot;
    const checkboxes = shadowRootContent.querySelectorAll('input[type="checkbox"]');
    let allChecked = true; //to check value of select all checkbox
    // loop through all checkboxes to check if all are checked
    checkboxes.forEach((ele, index) => {
      // check if the checkbox is checked and the row is not print
      const isCampaignSent = this.state.channelsData.some((item)=>  'online-'+item.channel_name === ele.id && item.export_status === 'Campaign Sent');
      // if the checkbox is checked and the row is print, then uncheck the checkbox
      if(event.target.checked && isCampaignSent){
        ele.checked = event.target.checked;
      }
      if (index && !ele.checked) {
        allChecked = false;
      }
    });
    const selectAll = shadowRootContent.getElementById(`${media}-placements-table-selectall`); //get select all checkbox element
    selectAll.checked = allChecked;
    let updated = [...this.state.channelsData].map((ele) => {
      if (ele.channel_name === value.channel_name) {
        return { ...ele, checked: event.target.checked }; // update checked value on selection
      } else if(event.target.checked && ele.export_status === 'Campaign Sent'){
        return { ...ele, checked: true }; // update checked value on selection
      }
      return ele;
    });
    this.setState({
      channelsData: updated, // update data in state after checkbox selections
    });
  };

  /**
   * Function to navigate to placement details page on click of supplier name
   * @param {string} supplierName supplier name
   * @returns {void}
  */ 
  navigateToPlacement = (value) => {
    let state = { campaignObj: this.state?.campaignObj };
    this.props.navigate(`/placementDetailsTable/${this.state.campaignObj?.id}/${value.channel_name}/${value.publisher_name}`, { state });
  }

  /**
   * function is to check local currancy apply and then return local currancy
   * @param {object} value 
   * @param {string} currancyKey 
   * @param {string} localCurrancyKey 
   * @returns return currancy local or USD currancy
   */
  createCurrancyType(value,currancyKey,localCurrancyKey){
    let displayValue = '';
    //this function for both Create child campaign and campaign campaign position change in props 
    const currency = this.state?.campaignObj?.local_currency_name || this.props?.campaignObj?.local_currency_name;
    if(this.props?.systemParametersData?.data?.isLocal && currency){
      displayValue = Utils.getLocalCurrency(currency, value[localCurrancyKey])
    }else{
      displayValue = Utils.getLocalCurrency('USD', value[currancyKey]);
    }
    return displayValue;
  }
  /**
   * Create Left side of column for campaign detail table it will not include in sticky area
   * @param {string} media 
   * @returns column As Array
   */
  getMediaMixLeftColumns(media) {
    return [
      {
        label: html`<input
          type="checkbox"
          part="checkbox"
          id="${media}-placements-table-selectall"
          ${this.state?.mediaSelectAll ? "checked" : ""}
          @click=${this.selectAllChannels.bind(this, media, false)}
        />`,
        key: "checked",
        template: (value, index) => {
          if (value.channel_name) {
            return html`
            <style>
            :host::part(checkbox){
              height: 16px !important;
              width: 16px !important;
            }

            :host::part(td-content) {
              color: var(--color-grey-600) !important;
            }

            :host span {
              font-size: 14px !important;
            }

            :host::part(th-content) {
              font-size: 12px !important;
            }

            .omni input[type=checkbox] {
              width: revert;
              margin-top: 8px;
              accent-color: var(--fill-primary);
            }

            .omni a {
              padding-left: 10px !important;
              color: var(--color-primary) !important;
              font-size: 14px !important;
            }

            .omni a:hover {
              text-decoration: underline !important;
            }

            :host::part(table-channel-name) {
              padding-left: 0px !important;
              color: var(--color-grey-900) !important;
              font-weight: 600 !important;
            }
            :host::part(planning-system-amount) {
              min-width: 280px !important;                  
            }
            :host::part(over-budget) {   
              color: var(--text-error) !important;
            }
            </style>

            <div part="table-body-cell" id="td-${value.id || (value && value["_hash"])}">
                <input type="checkbox" id="${media}-${value.id || (value && value["_hash"]) || value.channel_name}-${index}"
                name="${value.id}"
                part="checkbox"
                ?checked=${value.checked}
                ${value.checked ? "checked" : ""}
                @click=${this.handleCheckboxChange.bind(this, value, index, media, false,)}/>
            </div>`;
          }
        },
        isSortable: false,
        passthrough: true,
      },
      {
        label: "CHANNEL",
        key: "name",
        isSortable: true,
        passthrough: true,
        isMain: true,
        template: (value) => {
          if (value?.publisher_name && value?.publisher_type !== "Ad Serving" && value?.publisher_type !== "Ad Verification") {
            return html`<td part="table-body-cell">
              <a class="channel" part="table-child-row"  @click=${this.navigateToPlacement.bind(this, value)}>${value?.displayName}</a>
            </td>`;
          } else {
            return html`<td part="table-body-cell">
              <span class="channel" part="table-channel-name">${value?.displayName}</span>
            </td>`;
          }
        }
      },
            {
        label: html`
          <style>
            omni-tooltip-next [slot="content"] {
              text-transform: none !important;
            }
          </style>
          <div style="display: flex; align-items: center; white-space: nowrap;">
            ${this.state?.campaignObj?.parent_id ?
              html`<omni-tooltip-next place="top" interactive>
                <div slot="content" style="text-transform: none !important;">
                  This amount can be changed directly in Media Ops Hub. <br/> Note: This could differ from the original planned budget.
                </div>
                <div slot='invoker' aria-haspopup='true' aria-label="Planning System Amount information" tabindex="0" style="display: inline-block;">
                  <omni-icon icon-id="omni:informative:info" style="font-size: 12px; cursor: pointer;"></omni-icon>
                </div>
              </omni-tooltip-next>` :
              html``
            }
            <span style="margin-right: 4px; font-size: 12px !important;">Planning System Net Media</span>
          </div>
        `,
        key: "mediaocean_budget",
        default: "",
        isSortable: true,
        passthrough: true,
        template: (value) => {
          if (value?.publisher_type === 'channel') {
            const displayValue = this.createCurrancyType(value, 'channel_total_budget_in_pmds', 'channel_total_budget_in_pmds_local');
            return html`<td part="table-body-cell planning-system-amount">
            <span part="td-content">${displayValue}</span></td>`;
          } else if (value?.publisher_type === 'Supplier') {
            const displayValue = this.createCurrancyType(value, 'publisher_budget_in_pmds', 'publisher_budget_in_pmds_local');
            return html`<td part="table-body-cell planning-system-amount">
            <span part="td-content">${displayValue}</span></td>`;
          } else {
            let displayValue = '';
            let currancyName = ''

            if (this.props?.systemParametersData?.data?.isLocal && value?.totalFeeAmountLocal) {
              displayValue = value.totalFeeAmountLocal;
              currancyName = this.state.campaignObj?.local_currency_name
            } else {
              displayValue = value.totalFeeAmount;
              currancyName = 'USD'
            }
            return html`<td part="table-body-cell planning-system-amount">
            <span part="td-content">${PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(displayValue, false, currancyName)}</span></td>`;
          }
        },
      },
      {
        label: "MOH NET MEDIA",
        key: "budget",
        default: "",
        isSortable: true,
        passthrough: true,
        template: (value) => {
          if (value?.publisher_type === 'channel') {
            const displayValue = this.createCurrancyType(value, 'channel_total_budget_by_placements', 'channel_total_budget_by_placements_local');
            return html`<td part="table-body-cell">
            <span part="td-content">${displayValue}</span></td>`;
          } else if (value?.publisher_type === 'Supplier') {
            const displayValue = this.createCurrancyType(value, 'publisher_budget_by_placements', 'publisher_budget_by_placements_local');
            return html`<td part="table-body-cell">
            <span part="td-content">${displayValue}</span></td>`;
          } else {
            return html`<td part="table-body-cell"></td>`;
          }
        },
      },
      {
        label: "Fee Type",
        key: "publisher_type",
        default: "",
        isSortable: true,
        passthrough: true,
        template: (value) => {
          if (value?.publisher_type !== 'channel') {
            return html`<td part="table-body-cell">
              <span part="td-content">${value?.publisher_type}</span></td>`;
          } else {
            return html`<td part="table-body-cell"></td>`;
          }
        },
      },
      {
        label: "Fee Amount",
        key: "totalFeeAmount",
        default: "",
        isSortable: true,
        passthrough: true,
        template: (value) => {
          let displayValue = '';
          let currancyName = ''
          if(this.props?.systemParametersData?.data?.isLocal && value?.totalFeeAmountLocal){
            displayValue = value.totalFeeAmountLocal;
            currancyName = this.state.campaignObj?.local_currency_name
          } else {
            displayValue = value.totalFeeAmount;
            currancyName = 'USD'
          }          

          return html`<td part="table-body-cell">
            <span part="td-content">${PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(displayValue,false,currancyName)}</span></td>`;
        },
      },
      {
        label: "MOH Total Amount",
        key: "totalBudget",
        default: "",
        isSortable: true,
        passthrough: true,
        template: (value) => {
          const currency = this.state?.campaignObj?.local_currency_name || this.props?.campaignObj?.local_currency_name;
          let isLocal = this.props?.systemParametersData?.data?.isLocal && currency;
          if (value?.publisher_type === 'channel') {
            let isChannelOverBudget = false;
            value['totalAmountWithFees'] = value['channel_total_budget_by_placements'] + value['totalFeeAmount'];
            value['totalAmountWithFeesLocal'] = value['channel_total_budget_by_placements_local'] + value['totalFeeAmountLocal'];
            // Check for over budget
            if(isLocal && Number(value['totalAmountWithFeesLocal']) > Number(value['channel_total_budget_in_pmds_local']) || !isLocal && Number(value['totalAmountWithFees']) > Number(value['channel_total_budget_in_pmds'])){
              isChannelOverBudget = true;
              value['isOverBudget'] = true;
            }
            const displayValue = this.createCurrancyType(value, 'totalAmountWithFees', 'totalAmountWithFeesLocal');
            return html`<td part="table-body-cell">
            <span part="td-content ${isChannelOverBudget ? 'over-budget' : ''}">${displayValue}</span></td>`;
          } else if (value?.publisher_type === 'Supplier') {
            let isSupplierOverBudget = false;
            const displayValue = this.createCurrancyType(value, 'publisher_budget_by_placements', 'publisher_budget_by_placements_local');
            // Check for over budget
            if(isLocal && Number(value['publisher_budget_by_placements_local']) > Number(value['publisher_budget_in_pmds_local']) || !isLocal && Number(value['publisher_budget_by_placements']) > Number(value['publisher_budget_in_pmds'])){
              isSupplierOverBudget = true;
              value['isOverBudget'] = true;
            }
            return html`<td part="table-body-cell">
            <span part="td-content ${isSupplierOverBudget ? 'over-budget' : ''}">${displayValue}</span></td>`;
          } else {
            const displayValue = this.createCurrancyType(value, 'publisher_budget', 'publisher_budget_local');
            return html`<td part="table-body-cell">
            <span part="td-content">${displayValue}</span></td>`;
          }
        },
      },
      {
        label: "Amount Sent",
        key: "amount_sent",
        default: "",
        isSortable: true,
        passthrough: true,
        template: (value) => {
          const displayValue = this.createCurrancyType(value,'amount_sent','amount_sent_local');
          let color = 'var(--text-error)';
          if((this.props?.systemParametersData?.data?.isLocal && Number(value?.amount_sent_local) === Number(value?.budgetLocal)) ||
          Number(value?.amount_sent) === Number(value?.budget)){
            color = 'var(--text-success)';
          }
          return displayValue ? html`<td part="table-body-cell">
            <span style="color: ${color} !important">${displayValue}</span></td>` : html`<td></td>`;
        },
      },
      // removing mediaocean budget column and keeping the code for future reference
      // {
      //   label: "MEDIAOCEAN BUDGET",
      //   key: "mediaocean_budget",
      //   default: "",
      //   isSortable: true,
      //   passthrough: true,
      //   template: (value) => {
      //     const displayValue = this.createCurrancyType(value,'mediaocean_budget','mediaocean_budget_local');
      //     return html`<td part="table-body-cell">
      //       <span part="td-content">${displayValue}</span></td>`;
      //   },
      // },
      // removing AUTHORIZATION column and keeping the code for future reference
      // {
      //   label: "AUTHORIZATION",
      //   key: "authorized_amount",
      //   default: "",
      //   isSortable: true,
      //   template: (value) => {
      //     return html`<td part="table-body-cell">
      //     <span part="td-content">${value}</span>
      //   </td>`;
      //   },
      // },
      {
        label: "START DATE",
        key: "startDate",
        default: "",
        isSortable: true,
        passthrough: true,
        template: (value) => {          
          return html`<td part="table-body-cell">
              <span part="td-content">${Utils.formatDateObject(value?.startDate)}</span>
            </td>`;
        },
      },
      {
        label: "END DATE",
        key: "endDate",
        default: "",
        isSortable: true,
        passthrough: true,
        template: (value) => {
            return html`<td part="table-body-cell">
              <span part="td-content">${Utils.formatDateObject(value?.endDate)}</span>
            </td>`;
          
        },
      },
    ];
  }

  /**
   * Create Right side of table column for campaign detail table include in sticky area
   * @returns column As Array
   */
  getMediaMixRightColumns(media) {
    let row = [{
      label: "EXPORT STATUS",
      key: "export_status",
      default: "",
      isSortable: true,
      passthrough: true,
      template: (value) => {
        return html`
          <td part="table-body-cell">${exportStatusHtml.getExportHTML(value,'', value.exportStatusError )}</td>`; 
        }
      }];
      if(this.state.campaignObj?.delivered_campaigns?.length){
        row.push({
            label: "IN PLATFORM STATUS",
            key: "inPlatform_status",
            default: "",
            isSortable: false,
            passthrough: true,
            template: (value, index) => {
              return html`
              ${value.publisher_type && index === 0 ? html`<td part="table-body-cell">${this.getInPlatformView(value)}</td>` : html`<td part="table-body-cell"></td>`}`
            }
        })
      }
      return row;
  }

  /**
   * The below function will return HTML for the In-Platform status details in a tooltip on hover of the info icon. 
   * The tooltip will display the platform name and campaign name for each campaign in the delivered_campaigns array.
   * @param {object} value - The value of the cell.
   * @returns {string} - The HTML for the In-Platform status details.
  */ 
  getInPlatformView = (value) => {
    return html`
      <style>
        .in-platform-status {
          display: flex;
          justify-content: space-between;
        }
        .in-platform-status omni-tooltip-next {
          --tooltip-background-color : white;
          --tooltip-text-color: black;
        }
        .in-platform-status omni-icon {
          cursor: pointer;
        }
        .in-platform-status .in-platform-data {
          border: 1px solid #EDF0F5;
          border-radius: 10px;
          width: 500px;
        }
        .in-platform-data .in-platform-header div {
          padding: 12px 20px 12px 20px;
          font-size: 14px;
          font-weight: 600;
          color: #3B3E3F;
          border-bottom: 1px solid #EDF0F5
        }

        .in-platform-data .in-platform-body {
          max-height: 180px;
          overflow-y: auto;
        }
        .in-platform-body .in-platform-details {
          display: flex;
          flex-direction: column;
          padding: 24px 20px 24px 20px;
          min-height: 100%;
        }
        .in-platform-data .name {
          font-size: 12px;
          color: #3B3E3F;
          margin-bottom: 5px;
        }

        .in-platform-data .value {
          font-size: 14px;
          font-weight: 600;
          color: #3B3E3F;
          margin-bottom: 30px;
          word-break: break-all;
        }
      </style>

      <div class="in-platform-status">
        <span>In Platform</span>
        <omni-tooltip-next place="left" interactive>
          <omni-icon class="is-size-2 mb-2 is-normal" slot="invoker" aria-label="in-platform-info" icon-id="omni:informative:info"></omni-icon>
          <div slot="content">
            <div class="in-platform-data">
              <div class="in-platform-header">
                <div>In Platform Details</div>
              </div>
              <div class="in-platform-body">
              ${this.state.campaignObj.delivered_campaigns.map((campaign) => {
                return html`
                <div class="in-platform-details">
                  <span class="name">Platform Name</span>
                  <span class="value">${campaign.platform_name}</span>
                  <span class="name">Campaign Name</span>
                  <span class="value">${campaign.campaign_name}</span>
                </div>`
              })}
              </div>
            </div>
          </div>
        </omni-tooltip-next>
      </div>`
  }

  //show/hide media mix content on toggle of accordion icon
  openAccordion = (mediaMix) => {
    if (mediaMix === 'online') {
      this.state.displayOnlineAccordionContent === "none"
        ? this.setState({ displayOnlineAccordionContent: "block" })
        : this.setState({ displayOnlineAccordionContent: "none" });
    } else {
      this.state.displayPrintAccordionContent === "none"
        ? this.setState({ displayPrintAccordionContent: "block" })
        : this.setState({ displayPrintAccordionContent: "none" });
    }
  };

  /**
   * Function to handle the expand or collapse of the child row & calling the placement API of the child campaign if not called before
   * After calling the placement API, it will segregate the publishers and store it in the campaignChildPublisherList object
   * @param {any} event event details of the click child row
   * in if condtion ,sending 'versionOneApi' in 'getplacement' call, to find which version  of PDMS we are using,then use api as per version
   */
  onExpandOrCollapse = (event) => {
    if(event?.detail?.isMOChild && !this.campaignChildPublisherList[event?.detail?.campaignId]){
      this.props.setSpinnerCount(1);
      let campaignId = encodeURIComponent(event.detail.campaignId);
        MediaOpsService.getPlacements(campaignId,null,this.props?.versionOneApi).then((response)=>{
            if(response.data.length){
              this.campaignChildPublisherList[event.detail.campaignId] = {};
              for(let i=0;i<response.data.length;i++){
                if(!['Child', 'DSP'].includes(response.data[i].package_type)){
                  let placementType = response.data[i].placement_type !== 'Social' ? response.data[i].placement_type : 'Paid Social';
                  let publisherDetail = {
                    name: response.data[i].site,
                    MObudget: response.data[i].planned_cost ? response.data[i].planned_cost : 0,
                  }
                  if(!this.campaignChildPublisherList[event.detail.campaignId][placementType]){
                    this.campaignChildPublisherList[event.detail.campaignId][placementType] = {total: 0, publishers: []};
                    this.campaignChildPublisherList[event.detail.campaignId][placementType].publishers.push(publisherDetail);
                    this.campaignChildPublisherList[event.detail.campaignId][placementType].total = publisherDetail.MObudget;
                  } else {
                    let publisherList = this.campaignChildPublisherList[event.detail.campaignId][placementType].publishers;
                    let isPublisherExist = false;
                    for(let i=0;i<publisherList.length;i++){
                      if(publisherList[i].name === publisherDetail.name){
                        publisherList[i].MObudget+= publisherDetail.MObudget;
                        this.campaignChildPublisherList[event.detail.campaignId][placementType].total+= publisherDetail.MObudget;
                        isPublisherExist = true;
                        break;
                      }
                    }
                    if(!isPublisherExist){
                      this.campaignChildPublisherList[event.detail.campaignId][placementType].publishers.push(publisherDetail);
                      this.campaignChildPublisherList[event.detail.campaignId][placementType].total+= publisherDetail.MObudget; 
                    }
                  }
                }
              }
              this.createTablesData();
            } else {
                AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: this.onExpandOrCollapse, title: 'Unable to find the providers', bodyMsgArr: []}]);
            }
        }).catch((err)=>{
          AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: this.onExpandOrCollapse, title: 'Unable to fetch the providers', bodyMsgArr: []}]);
        }).finally(()=>{
            this.props.setSpinnerCount(0);
        });
    }
  }

  /**
   * Check for over budget channels before sending to media ocean
   * @returns {boolean} true if any selected channel is over budget, false otherwise
   */
  checkForOverBudgetChannels = () => {
    let selectedChannels = this.state.channelsData.filter(item => item.checked);
    for(let i=0;i<selectedChannels.length;i++){
      if(selectedChannels[i].isOverBudget){
        this.setState({showOverBudgetModal: true}, () => {
          setTimeout(() => {
            const overBudgetModal = document.getElementById('over-budget-modal');
            overBudgetModal && overBudgetModal.showModal();
          }, 100);
        });
        return true;
      }
    }
    return false;  
  }

  /**
   * Function to create payload and call send to media ocean API
   * @returns {void}
  */
  setPayloadAndCallSendMOApi = () => {
    this.closeOverBudgetModal();

    const payload = {
      campaignTaxonomy: this.state.taxonomyName,
      campaignTaxonomyDisplay: this.state.taxonomyNameWithAbbrevation,
      taxonomySchema: this.state.taxonomySchema,
      userEmail: this.props && this.props.omniProfile && this.props.omniProfile['email'],
      channels: this.state.channelsData.filter(item => item.checked).map(item => item['channel_name']),
      isCurrencyLocal: this.props?.systemParametersData?.data?.isLocal,
      campaignStartDate: this.state.campaignObj?.startDate,
      campaignEndDate: this.state.campaignObj?.endDate
    };
    this.props.setSpinnerCount(1);
    let responseMsgArr = [];
    let campaignId = encodeURIComponent(this.state.campaignObj.id);
    MediaOpsService.sendCampaignToMediaOcean(payload, campaignId, this.props?.versionOneApi).then((response) => {
      if (response.status.trim() === "error") {
        responseMsgArr.push({ type: "danger", retryBtnText: 'Retry', retryBtnEvent: this.sendToMediaOcean, title: "Campaign is not sent to Media Ocean", "bodyMsgArr": [html`${response?.message}`] })
        AlertMessagesService.showMultipleAlerts(responseMsgArr)
      } else {
        this.props.setCampaignTableData({});
        AlertMessagesService.showSuccessToastMessage(`Selected channel(s) for ${this.state.campaignObj.campaign_name} are sent to Media Ocean`);
        if (this.props.displayPreview) {
          this.props.navigate('/')
        }
      }
    }, (error) => {
      AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Retry', retryBtnEvent: this.sendToMediaOcean, title: 'Unable to send the campaign to the Media Ocean', bodyMsgArr: [error?.response?.data?.error?.message] }]);
    }).finally(() => {
      // get updated campaign data after sending to media ocean
      this.getCampaignData(true, true, true);
      const onlineTable = document.getElementById(`online-table`);
      const printTable = document.getElementById(`print-table`);
      if (onlineTable) {
        this.selectAllChannels('online', false, { target: { checked: false } });
        const onlineLeftTable = onlineTable.shadowRoot.getElementById(`left-table`);
        onlineLeftTable && (onlineLeftTable.shadowRoot.getElementById(`online-placements-table-selectall`).checked = false);
      }
      if (printTable) {
        this.selectAllChannels('print', false, { target: { checked: false } });
        const PrintLeftTable = printTable && printTable.shadowRoot.getElementById(`left-table`);
        printTable && (PrintLeftTable.shadowRoot.getElementById(`print-placements-table-selectall`).checked = false);
      }
    });
  }

  /**
   * Function to close over budget modal
   * @returns {void}
  */
  closeOverBudgetModal = () => {
    const overBudgetModal = document.getElementById('over-budget-modal');
    overBudgetModal && overBudgetModal.close();
    this.setState({ showOverBudgetModal: false });
  }

  /**
   * Function to send selected channels to media ocean
   * This method first checks for any over budget channels. If any are found, it displays a modal and exits.
   * If no over budget channels are found, it proceeds to create a payload with selected channels and send to media ocean
   * and display success or error message based on the API response.
   * After the API call is finished the checkboxes of the table are unchecked,
  */
  sendToMediaOcean = () => {
    if (this.checkForOverBudgetChannels()) {
      return;
    }
    this.setPayloadAndCallSendMOApi();
  };

  /**
   * Determines if the campaign needs an update and handles the update process.
   * 
   * This method checks if the campaign has a parent ID. If it does, it opens the child campaign modal and updates the
   * parent campaign online table. If the campaign does not have a parent ID, it updates the campaign's export status
   * based on the current button text.
   * 
   */
  needsUpdate = () => {
    // Check if client code is assigned, If not, show the warning
    if(!this.state.campaignObj.client_code){
      AlertMessagesService.showWarningToastMessage('Client code is not assigned yet, Please assign the Client code before proceeding');
      return;
    }
    if (this.state?.campaignObj?.parent_id) {
      if(this.state?.parentCampaign?.id){
        this.setState({ isChildCampaignModalOpen: true, editChildCampaign: true }, () => {
          TableUtils.checkSelectAll(this.state.parentCampaignOnlineArr, 'campaign-online-table-selectall');
          const tableRef = document.getElementsByClassName('parent-campaign-table')[0];
          tableRef?.requestUpdate();
        })
      }else {
        AlertMessagesService.showWarningToastMessage('Parent campaign is not available, Please try again later');
        this.props.setSpinnerCount(0);
      }
    } else {
      let payload = { exportStatus: "Needs Update" };
      if (this.state.needsUpdateBtnText === "Confirm Update") {
        payload.exportStatus = "Updated";
      }
      this.updateCampaign(payload, null, '', true);
    }
  };

  /**
   * Saves the changes made to the child campaign.
   * 
   * This method collects the selected channels and publishers, prepares the payload with the updated data,
   * and sends a request to update the campaign. It handles the response by showing success or error messages
   * and updating the component state accordingly.
   * 
   */
  saveChildCampaignChanges = () => {
    this.props.setSpinnerCount(1);
    const channelsList = this.state.parentCampaignOnlineArr.filter(item => item?.checked === 'all' || item?.checked === 'some');
    const printChannelsList = this.state.parentCampaignPrintArr.filter(item => item?.checked === 'all' || item?.checked === 'some');
    channelsList.push(...printChannelsList);
    let channelListForPayload = channelsList.map(channel => {
      let isLocal = this.props?.systemParametersData?.data?.isLocal;
      let currency = this.state.campaignObj.local_currency_name;
      let filed = isLocal && currency ? 'budgetLocal' : 'budget';
      channel.publishers = channel.publishers.filter(publisher => publisher.checked === 'all' || publisher.checked === 'some');
      return {
        channel_name: channel.channel_name,
        channel_startdate: channel.startDate || null,
        channel_enddate: channel.endDate || null,
        channel_total_budget: channel[filed] ? Number(String(channel[filed]).replace(/,/g, '')) : 0,
        tier_id: channel.channel_tier_id,
        publishers: channel.publishers.map(publisher => {
          return {
            publisher_name: publisher.publisher_name,
            publisher_budget: publisher[filed] ? Number(String(publisher[filed]).replace(/,/g, '')) : 0,
            publisher_type: publisher.publisher_type,
            publisher_start_date: publisher.startDate || null,
            publisher_end_date: publisher.endDate || null
          };
        })
      };
    });

    // Apply text case transformation using utility function
    const transformedTaxonomy = PlacementUtils.transformValueToGivenCase(this.state.taxonomyName, this.props.campaignTaxonomyData?.taxonomyTextcase);
    const transformedTaxonomyDisplay = PlacementUtils.transformValueToGivenCase(this.state.taxonomyNameWithAbbrevation, this.props.campaignTaxonomyData?.taxonomyTextcase);

    const payload = {
      'campaign_name': this.state.campaignObj?.campaign_name,
      'campaign_taxonomy': transformedTaxonomy,
      'campaign_taxonomy_display': transformedTaxonomyDisplay,
      'campaignStartDate': this.state?.childCampaignStartDate,
      'campaignEndDate': this.state?.childCampaignEndDate,
      'taxonomy_schema': this.state.taxonomySchema,
      'client_code': this.state.clientCode,
      'parent_id': this.state?.parentCampaign?.id,
      'channels': channelListForPayload,
      'is_currency_local': this.props?.systemParametersData?.data?.isLocal,
      'parent_campaign_total_budget': this.state.parentCampaign?.campaign_total_budget,
      'parent_campaign_total_budget_local': this.state.parentCampaign?.campaign_total_budget_local,
      "source": "MediaOps",
    }

    let campaignId = encodeURIComponent(this.state.campaignObj.id);

    MediaOpsService.updateCampaign(payload, campaignId, this.props?.versionOneApi).then((response) => {
      AlertMessagesService.showSuccessToastMessage('Planned Platform Campaign is updated.');
      trackEvent(`Campaign update is success.`, { access_from: 'Campaign Details Page', campaignId });
      this.handleChildCampaignModalClose();
      MediaOpsService.getCampaignDataById(campaignId, this.state?.campaignObj?.client_id, this.props?.versionOneApi)
        .then((resp) => {
          const campaignObj = MediaOpsService.prepareCampaignData(resp)[0];
          if (!campaignObj?.local_currency_name) {
            campaignObj.local_currency_name = this.state?.parentCampaign?.local_currency_name;
          }
          this.setState({ campaignObj }, () => {
            this.processCampaignData(this.state.campaignObj, false, false)
            this.props.setCampaignTableData({});
            this.props.setSpinnerCount(0);
          });
        }, (error) => {
          AlertMessagesService.showErrorToastMessage(`Unable to get the Planned Platform Campaign. Please try again. ${error}`);
          this.props.setSpinnerCount(0);
        })
    }, (error) => {
      trackEvent(`Campaign update is failed.`, { access_from: 'Campaign Details Page', campaignId, event: { error: error?.response?.data } });
      AlertMessagesService.showErrorToastMessage(`Planned Platform Campaign is not updated. Please try again. ${error}`);
      this.props.setSpinnerCount(0);
    })
  }

  /**
   * Function is use to update campaign detail and update campaign through edit campaign input
   * after successfully call, it will update campaign object in state if client code is updated.
   * If other value updated it will navigate to campaign table page
   * 
   * @param {object} payload have campaign updated values
   * @param {number} index to close capaign edit popup
   * @param {string} id remove active class from campaign edit popup button
   */
  updateCampaign = (payload,index = null,id = '', needsUpdate = false, nameChange = false) => {
    this.props.setSpinnerCount(1);
    let campaignId = encodeURIComponent(this.state.campaignObj.id);
    MediaOpsService.updateCampaign(payload, campaignId, this.props?.versionOneApi).then(
      (response) => {
        this.updateCampaignAfterReesponse(payload, index, id);
        if (needsUpdate) {
          if (payload?.exportStatus === 'Needs Update') {
            trackEvent(`Campaign needs update is success.`, { access_from: 'Campaign Details Page', campaignId });
          } else if (payload?.exportStatus === 'Updated') {
            trackEvent(`Campaign confirm update is success.`, { access_from: 'Campaign Details Page', campaignId });
          }
        }

        if (nameChange) {
          trackEvent(`Campaign Taxonomy is updated.`, { access_from: 'Campaign Details Page', campaignId });
        }
      },
      (error) => {

        if (nameChange) {
          trackEvent(`Campaign Taxonomy update is failed.`, { access_from: 'Campaign Details Page', campaignId, event: { error: error?.response?.data } });
        }

        if (needsUpdate) {
          if (payload?.exportStatus === 'Needs Update') {
            trackEvent(`Campaign needs update is failed.`, { access_from: 'Campaign Details Page', campaignId, error: error?.response?.data });
          } else if (payload?.exportStatus === 'Updated') {
            trackEvent(`Campaign confirm update is failed.`, { access_from: 'Campaign Details Page', campaignId, error: error?.response?.data });
          }
        }

        if(payload?.clientCode){
          AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.updateCampaign(payload, index, id), title: 'Client API cannot be loaded', bodyMsgArr: []}]);
        }
        if(payload?.campaignTaxonomy){
          AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.updateCampaign(payload, index, id), title: 'Campaign Taxonomy API cannot be loaded', bodyMsgArr: []}]);
        }
        if((!payload?.clientCode && !payload?.campaignTaxonomy) && payload.exportStatus === 'Needs Update' ){
          AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.updateCampaign(payload), title: 'Unable to update the campaign', bodyMsgArr: []}]);
        }
        this.props.setSpinnerCount(0);
    })
  };

  updateCampaignAfterReesponse = (payload, index=null, id='') => {
    this.props.setCampaignTableData({});
    MediaOpsService.campaignSentToMediaOcean = this.state.campaignObj.id;
    let campaignObj = this.props.state.campaignObj;
    if(payload?.clientCode){
      campaignObj.client_code = payload.clientCode;
      this.setState({ campaignObj: campaignObj, clientCode:payload.clientCode, popupVisible: false });
      AlertMessagesService.showSuccessToastMessage('Client Id is Updated.');
      this.getCampaignData(true, true, false);
    }else if(payload?.campaignTaxonomy){
      campaignObj.campaignTaxonomy = payload.campaignTaxonomy;
      campaignObj.campaign_taxonomy = payload.campaignTaxonomy;
      campaignObj.campaign_taxonomy_display = payload.campaignTaxonomyDisplay;
      campaignObj.taxonomy_schema = payload.taxonomySchema;
      if(this.state.campaignObj.data_source === 'Mediaocean'){
        //these value have same as txonomy Taxonomy 
        campaignObj['campaign_name'] = payload.campaignName
        campaignObj.campaignName = payload.campaignName
        campaignObj['campaign name/description'] = payload.campaignName
        this.props.setCampaignName(payload.campaignName);
      }
      
      this.setState({ 
        campaignObj: campaignObj,
        selectedDDValue: { name: '', value: null },
        displayTaxonomySyncModal: false, 
        selectedTaxonomyFromSync: '',
        popupVisible: false
        }, () => {      
        this.genrateCampaignTaxonomyName(true)           
      });
      AlertMessagesService.showSuccessToastMessage('Campaign Taxonomay is Updated.');
      this.onCancelCampaignUpdate(index,id)
      this.getCampaignData(true, true, false);
    }
    else{
      this.props.setSpinnerCount(0);
      this.gotoCampaignTable();
    }
  }
    /**
   * Get client code from API for Campaign detail form
   * update client codes state object that value is used inside of campaign detail form for client id drop down
   */
  getClientCode = () => {
    MediaOpsService.getClientCodes().then(
      (response) => {
        // let clientId = this.state.campaignObj.clientid;
        // let clientIds = Array.isArray(clientId) ? [...new Set(clientId)] : clientId ? [clientId] : [];
        // clientIds = clientIds.filter(Boolean);
        let clientCodes = [...response?.data?.client_codes]

        // if (response?.data?.client_codes?.length) {
        //   clientCodes = [...response?.data?.client_codes, ...clientIds]
        // } else {
        //   clientCodes = clientIds
        // }
        this.setState({
          clientCodes: clientCodes,
          clientCode: this.state.campaignObj.client_code
        });
      }
    ).finally(() => {
      this.props.setSpinnerCount(0);
    });
  };

  // /**
  //  * The function `getCampaignTaxonomyName` takes a Campaign object and returns an
  //  * array of HTML elements representing the campaign Taxonomy names for that campaign.
  //  * @param campaignDetail - The `campaignDetail` parameter is an object that contains information about `campaign`, 
  //  * @returns an array of HTML elements representing rows of campaign names.
  //  */
  // getCampaignTaxonomyName(taxonomyName) {
  //   let taxonomySchemaArray = this.props.campaignTaxonomyData.fields;
  //   let campaign = this.state.campaignObj;
  //   let taxonomyJson = campaign?.taxonomy ?  campaign?.taxonomy : null;
  //   let campaignTaxonomy = taxonomyName.split(':|');
  //   taxonomyName = campaignTaxonomy[0];
  //   let taxonomySchema = campaign?.taxonomy_schema ?  campaign?.taxonomy_schema : null;

  //   let campaignValue = PlacementDetailsTableService.splitPlacementStringIntoSchemaObject(taxonomyName, taxonomySchema, taxonomySchemaArray, '', null, null, taxonomyJson);
  //   // let campaignObj = PlacementDetailsTableService.updateFormDataWithJsonData(taxonomySchemaArray,campaigin,'campaignTaxonomy');
    
  //   let taxonomyNameArr = Object.values(campaignValue);
  //   //it create campaign name in Table and user can edit it by click on any camapaign name value 
  //   let rows = taxonomyNameArr.map((item, nameIndex) => {
  //     let taxonomyField = taxonomySchemaArray[nameIndex];
  //     const title = taxonomyField ? taxonomyField?.alias || taxonomyField?.name :''
  //     let isDisabled = taxonomyField ? false : true; 
  //     return (
  //       <div key={`${nameIndex}-campaign-taxonomy`} className={isDisabled ? 'campaign-taxonomy-disable' : 'campaign-taxonomy'} style={{ paddingTop:'5px',paddingBottom:'5px' }}>
  //         <div part="campaign" style={{ display: "flex", cursor: 'pointer' }}>
  //           <OmniTooltipNextComponent>
  //             <span slot="invoker" id={`campaign=${nameIndex}-campaign-taxonomy`} part="campaign-name" className="placement dropdown">
  //               {
  //                 taxonomyField?.field_type === 9 || taxonomyField?.field_type === 10? 
  //                   (<span className="static-field">{item}</span>) : 
  //                   (<span onClick={() => isDisabled ? '' : this.campaignNameClick(nameIndex)}>{item}</span>)
  //               }
  //             </span>
  //             <div slot="content">{title}</div>
  //           </OmniTooltipNextComponent>
  //           {taxonomyNameArr.length - 1 === nameIndex ? '' : taxonomyField?.delimiter_value}
  //         </div>
  //         {isDisabled ? '' : this.campaignTaxonomyEditpopup(nameIndex, item, taxonomyNameArr, taxonomyField, taxonomyField?.delimiter_value,campaignValue)}
  //       </div>
  //     )
  //   });    
  //   return rows;
  // }

  /**
   * Function open popup modal for edit campaign name
   * close previous open popup modal
   * @param {number} index name index value
   */
  campaignNameClick(index) {
    this.setState({
      selectedDDValue :{
        name:'',value:null
      }
    });
    if(this.previousOpendPopUpIndex !== null){
      let lasPopuDiv = document.getElementById(`popup-${this.previousOpendPopUpIndex}-campaign-Taxonomy`)
      lasPopuDiv.classList.remove("edit-popup-active");
    }
    let popUpDiv = document.getElementById(`popup-${index}-campaign-Taxonomy`)
    popUpDiv.classList.add("edit-popup-active");
    this.previousOpendPopUpIndex = index;
  }

  /**
   * campaignTaxonomyEditpopup function generates an HTML template for an edit popup to modify campaign data for a specific index and row in a dropdown or input field.
   * @param {number} index - The index of the field within the campaign name data.
   * @param {Object} campaignDetail - The campaign data object.
   * @param {string} name - The key containing the display value for the campaign Name.
   * @param {array} taxonomyNameArr - The key containing campaign Name as Array.
   * @param {Array} taxonomyFieldList - The key containing list of fields.
   * @returns {string} - An HTML template representing the edit popup for the campaign.
   */
  // campaignTaxonomyEditpopup(index,name,taxonomyNameArr,taxonomyFieldList,delimiterValue,campaignValue) {
  //   let ddValue =  name;
  //   let fieldName ='';
  //   fieldName = campaignValue[taxonomyFieldList?.name] ?  taxonomyFieldList?.name : taxonomyFieldList?.alias;

  //   if(!fieldName || !ddValue){
  //       return ``;
  //   }
  //   let ddValues = [];
  //   taxonomyFieldList.fielditems.forEach(item => {
  //     ddValues.push({
  //       value: item.name,
  //       id: item.code
  //     })
  //     if(item.code === name){
  //       ddValue = {
  //         value: item.name,
  //         id: item.code
  //       }
  //     }
  //   });
    
  //   let applyButtonId = `edit-aply-btn-${index}-campaign-Taxonomy`;
  //   return (
  //       <div  part="dropdown"  className="edit-popup" style={{width: "349px"}} id={`popup-${index}-campaign-Taxonomy`} key={`popup-${index}-campaign-Taxonomy`}>
  //       <div part="dropdown-menu" className="dropdown-menu1" role="menu">
  //           <div part="dropdown-content" className="dropdown-content" style={{display: "flex",flexDirection:"column"}}>
  //               <section part="dropdown-header">
  //                   <p className="object-title">{fieldName}</p>   
  //               </section>
  //               <section part="dropdown-section" className="dropdown-item" style={{padding: "0px 24px"}}>
  //                   <div part="dropdown-item" style={{margin:"15px 0 20px 0"}}>
  //           {(!ddValues || ddValues?.length === 0) ?
  //           ( <div  className="full-width">
  //                           <input part="input-control" type="text" className="input text medium"
  //                           value={this.state.selectedDDValue?.value != null? this.state.selectedDDValue?.value : ddValue}
  //                           title={taxonomyFieldList && taxonomyFieldList.allowed_space === false ? "Spaces are not allowed" : ""}
  //                           onChange={this.onCampaignInputChange.bind(this,fieldName,applyButtonId,delimiterValue,taxonomyFieldList)}></input>
  //                       </div>)
  //           :
  //            (<div className="input-container">
  //                       <OmniDropdownComponent
  //                       typeahead
  //                       searchindropdown
  //                       key={'campaign'+index}
  //                       value={this.state.selectedDDValue?.value && this.state.selectedDDValue?.name === fieldName ? [this.state.selectedDDValue] : [ddValue]}
  //                       options={ddValues}
  //                       originalOptions={ddValues}
  //                       hidefooter={true}
  //                       onDropdownChange={(e) => this.onCampaignDropDownChange(e.detail.id, fieldName,applyButtonId,ddValues,delimiterValue)}
  //                   ></OmniDropdownComponent>
  //                   </div>)
  //             }
  //                   </div>
  //                   <div className="action-btns" style={{display:"flex",justifyContent:"flex-end",alignItems: "center"}}>
  //                   <button className="tertiary medium" onClick={(e)=>this.onCancelCampaignUpdate(index,applyButtonId)}>Cancel</button>
  //                   <button className="medium" id={`${applyButtonId}`}  onClick={(e)=>this.onApplyBtnClickForCampaignNameChange(index,applyButtonId,delimiterValue,campaignValue)}>Apply</button>
  //                   </div>
  //               </section>
                
  //           </div>
  //       </div>
  //       </div>);
  // }

  /** 
  * Description; to change the input value from dropdown
  * @param {any} event 
  * @param {any} fieldName
  * @param {any} applyButtonId
  * @param {any} taxonomyField
  * @returns {any}
  */
  onCampaignInputChange = (fieldName, applyButtonId, delimiterValue, taxonomyField, event) => {
    let updatedValue = event.target.value;
    let applyBtn = document.getElementById(applyButtonId);
    
    // Check for space restriction if configured
    if (taxonomyField && taxonomyField.allowed_space === false && updatedValue.includes(' ')) {
      // Show error message for space restriction
      this.showSpaceErrorMessage(event.target);
      // Remove spaces from input and continue processing with cleaned value
      updatedValue = updatedValue.replace(/\s+/g, '');
      event.target.value = updatedValue;
    } else {
      // Clear any existing error messages when validation passes
      this.clearSpaceErrorMessage(event.target);
    }
    
    let value = delimiterValue ? updatedValue.split(delimiterValue)[0] : updatedValue;
    let selectedDDValue = {"value":value,"name":fieldName};
    this.setState({
      selectedDDValue :selectedDDValue
    });
    
    // Enable apply button when validation passes and there's a value
    if (applyBtn && value) {
      applyBtn.classList.add("active");
      applyBtn.disabled = false;
    } else if (applyBtn) {
      applyBtn.classList.remove("active");
      applyBtn.disabled = true;
    }
  }

  /**
   * Show error message for space restriction
   * @param {HTMLElement} inputElement - The input element that triggered the error
   */
  showSpaceErrorMessage = (inputElement) => {
    // Remove existing error messages
    const existingError = inputElement.parentNode.querySelector('.space-error-message');
    if (existingError) {
      existingError.remove();
    }

    // Create and show error message
    const errorDiv = document.createElement('div');
    errorDiv.className = 'space-error-message';
    errorDiv.style.color = 'red';
    errorDiv.style.fontSize = '12px';
    errorDiv.style.marginTop = '4px';
    errorDiv.textContent = 'Spaces are not allowed';
    
    inputElement.parentNode.appendChild(errorDiv);
    
    // Remove error message after 3 seconds
    setTimeout(() => {
      if (errorDiv.parentNode) {
        errorDiv.remove();
      }
    }, 3000);
  }

  /**
   * Clear space error message
   * @param {HTMLElement} inputElement - The input element to clear error for
   */
  clearSpaceErrorMessage = (inputElement) => {
    const existingError = inputElement.parentNode.querySelector('.space-error-message');
    if (existingError) {
      existingError.remove();
    }
  }

  /**
  * Description; this will update the campaign dropdown values
  * @param {any} updatedValue
  * @param {any} applyButtonId
  * @param {any} options
  * @param {any} fieldName
  * @returns {any}
  *  @returns campaign dropdown change.
  */
  onCampaignDropDownChange = (updatedValue, fieldName,applyButtonId,options,delimiterValue) => {
      let selOpt = options.find(obj => obj.id === updatedValue);
      if(selOpt){
          let selectedDDValue =  {"value":updatedValue.split(delimiterValue)[0],"label": selOpt.value, "name":fieldName,id:updatedValue}; 
          this.setState({
            selectedDDValue :selectedDDValue
          });
          let applyBtn = document.getElementById(applyButtonId)
          applyBtn.classList.add("active");
        }
  }

  /**
   * Close the popup modal and remove ative from apply button
   * @param {number} index name index 
   * @param {string} applyButtonId apply button id
   */
  onCancelCampaignUpdate = (index, applyButtonId) => {
    if(typeof index === "number" && index >= 0 && document.querySelector('#campaign-taxonomy-input')){
      let popUpDiv = document.getElementById(`popup-${index}-campaign-Taxonomy`)
      popUpDiv.classList.remove("edit-popup-active")
      let applyBtn = document.getElementById(applyButtonId)
      applyBtn.classList.remove("active");
      this.lastPopUpIndex = null;
      this.setState({
        selectedDDValue :{
          name:'',value:null
        }
      });
    }
  }

  /**
   * Get updated name and schema from the edit form data.
   * @param {Object} editFormData - The form data to extract values from.
   * @returns {Object} - An object containing the updated name, display name, schema, and taxonomy JSON.
  */
  getUpdatedNameAndSchema = (editFormData) => {
    let updatedName = '';
    let updatedDisplayName = '';
    let schema = '';
    let taxonomyJson = [];
    let taxonomySchemaArray = this.props.campaignTaxonomyData;

    let {taxonomySelectedValueJson} = PlacementUtils.createNames(editFormData, taxonomySchemaArray, true);
    updatedName = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'code',false,taxonomySchemaArray?.fields, this.state.isCreateChildCampaign);
    updatedDisplayName = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'name',false,taxonomySchemaArray?.fields, this.state.isCreateChildCampaign);
    schema = PlacementDetailsTableService.createStringFromJson(taxonomySelectedValueJson,'field_name',false,taxonomySchemaArray?.fields);
    taxonomyJson = taxonomySelectedValueJson.map((item) => {
      delete item['field_name'];
      delete item['name'];
      delete item['hidden'];
      return item;
    });

    return {
      updatedName,
      updatedDisplayName,
      schema,
      taxonomyJson
    };
  }

  /**
   * Handles the application of changes to the campaign name.
   *
   * @param {number} nameIndex - The index of the name in the taxonomy array to be updated.
   * @param {string} applyButtonId - The ID of the apply button that was clicked.
   * @param {string} delimiterValue - The delimiter used to split and join the taxonomy strings.
   *
   * Updates the campaign name, display name, and schema based on the selected dropdown value.
   * If the campaign is sourced from Mediaocean, it also updates the campaign name.
   * If not creating a child campaign, it updates the campaign directly.
   * Otherwise, it updates the state with the new campaign taxonomy and resets the spinner and selected dropdown value.
   */
  onApplyBtnClickForCampaignNameChange = (nameIndex, applyButtonId,delimiterValue,campaignValue) => {
    if (!this.state.selectedDDValue.name) return;
    this.setState({ spinnerCount: 1 });
    let updatedName = ''
    let updatedDisplayName = ''
    let schema = ''
    let taxonomyJson = [];
    if(campaignValue){
      campaignValue[this.state.selectedDDValue.name] = this.state.selectedDDValue.value;
      ({updatedName, updatedDisplayName, schema, taxonomyJson} = this.getUpdatedNameAndSchema(campaignValue));
    }else {
      let nameArr = this.state.taxonomyName.split(delimiterValue);
      nameArr[nameIndex] = this.state.selectedDDValue.value;
      let displayNameArr = this.state.taxonomyNameWithAbbrevation.split(delimiterValue);
      displayNameArr[nameIndex] = this.state.selectedDDValue?.label || this.state.selectedDDValue.value;
      let schemaArr = this.state.taxonomySchema.split('|');
      schemaArr[nameIndex] = this.state.selectedDDValue.name;
      schema = schemaArr.join('|');
      // Apply text case transformation using utility function
     updatedName = PlacementUtils.transformValueToGivenCase(nameArr.join(delimiterValue), this.props.campaignTaxonomyData?.taxonomyTextcase);
     updatedDisplayName = PlacementUtils.transformValueToGivenCase(displayNameArr.join(delimiterValue), this.props.campaignTaxonomyData?.taxonomyTextcase);
    }
    
    let payload = {
      campaignTaxonomy: updatedName,
      campaignTaxonomyDisplay: updatedDisplayName,
      taxonomySchema: schema,
      campaignStartDate: this.state.campaignObj?.startDate,
      campaignEndDate: this.state.campaignObj?.endDate,
      taxonomy: taxonomyJson,
      taxonomy_client_id: this.props.campaignTaxonomyData.clientid,
      taxonomy_schema_id: this.props.campaignTaxonomyData.id
    };

    if (this.state.campaignObj.data_source === 'Mediaocean') {
      payload.campaignName = payload.campaignTaxonomy;
    }

    if (!this.state?.isCreateChildCampaign && !this.props.displayPreview) {
      this.updateCampaign(payload, nameIndex, applyButtonId, false, true);
    }
  }

  /**
   * Closes the child campaign modal and resets related state properties.
   *
   * This method sets the state property `isChildCampaignModalOpen` to false, along with resetting `editChildCampaign`
   * and `enableSelectChannelButton` to false. After updating the state, it calls the `createParentCampaignTableData`
   * method to refresh the parent campaign data.
   *
   */
  handleChildCampaignModalClose = () => {
    this.setState({ isChildCampaignModalOpen: false, editChildCampaign: false, enableSelectChannelButton: false }, () => {
      this.createParentCampaignTableData();
    });
  }

  /**
   * function will trigger on click of toggle button
   * true/false value assign to variable 
   * add verfication and ad serving row will hide/show according to true/false vallue inside of createtable function
   * @param {object} event toggle event object
   * @param {string} tableType type of table online/Printe
   */
  onSwitch(event,tableType){
    if(tableType === 'online'){
      this.isOnlineSwitchOn = event.detail.checked;
    }else{
      this.isPrintSwitchOn = event.detail.checked;
    }
    this.createTablesData();
  }
  
  /**below methods are used for the child campaign creation*/

  // navigates to specific path using Utils.navigateToComponent()
  navigateToPath = (path) => {
    Utils.navigateToComponent({ ...this.props.state.campaignObj }, path, this.props, this.state.totalInOverallBudget)
  }

  /**
   * Formats a date string by removing the time component and returns the formatted date.
   * If the value is a string without a 'T' character, it returns an empty string.
   * Otherwise, it returns the value as is.
   *
   * @param {string} value - The date string to format.
   * @returns {string} - The formatted date string.
   */
  getDate = (value) => {
    const date = value && value.includes('T') ? value.split('T')[0] : value === 'string' ? '' : value;
    return Utils.formatDateObject(date);
  }

  /**
   * Handles the date change event for the campaign start and end dates.
   * Validates the selected date against the campaign's start and end dates and updates the state accordingly.
   *
   * @param {Object} event - The event object containing the name and value of the date input.
   */
  handleDate = (event) => {
    const { name, value } = event.target;
    const dateValue = new Date(this.getDate(value));
    const campaignStartDate = new Date(this.getDate(this.state.campaignObj.startDate));
    const campaignEndDate = new Date(this.getDate(this.state.campaignObj.endDate));

    if (campaignStartDate <= dateValue && campaignEndDate >= dateValue) {
      if (name === 'startDate' && dateValue <= campaignEndDate) {
        this.setState({ enableSelectButton: false });
      } else if (name === 'endDate' && (dateValue >= campaignStartDate)) {
        this.setState({ enableSelectButton: false });
      } else {
        this.setState({ enableSelectButton: true });
      }
    } else {
      this.setState({ enableSelectButton: true })
    }    
    this.setState({ [name]: value })
  };

  /**
   * Handles the change event for child campaign dates.
   * Updates the state with the new value and triggers validation.
   *
   * @param {Object} event - The event object from the input change.
   * @param {string} event.target.name - The name of the input field.
   * @param {string} event.target.value - The value of the input field.
   */
  handleChildCampaignDates = (event) => {    
    const { name, value } = event.target; 
    this.setState({ [name]: value }, () => this.updateSelectChannelButtonAndValidateNetMediaTotal(true));
  };

  /**
   * Generates a textbox input template for a table cell with custom styling.
   * The textbox displays a formatted currency value and updates the budget on change.
   *
   * @param {Object} value - The value object containing the field data.
   * @param {number} index - The index of the item in the list.
   * @param {string} field - The field name of the value.
   * @param {string} media - The type of media (e.g., 'online', 'print').
   * @returns {TemplateResult} - The HTML template for the textbox input field.
   */
  getTextboxTemplate = (value, index, field, media, budget, parentCampaign = false) => {    
    let errorMessage = html``;
    //budget is checking for both publisher and channel
    if (field.includes('budget') && value?.isChannelBudgetLessThanPublishers) {
      errorMessage = html`<span part="error-helper-text">Publishers total budget should be<br>less than or equal to channel budget</span>`;
    }

    return html`<td>
    <input id=${field + '-' + index}
      style="padding-left: 10px;font-weight: 600;"
      part="cell-input ${field}"
      class="input is-static is-editable"
      type="text"
      .value=${budget}
      @change=${(event) => { this.updateBudget(event, value, field, media, parentCampaign) }}>
    <br>
      ${errorMessage}
    </td>`;
  }


  /**
   * Updates the budget for a specific channel or publisher based on the provided event and value.
   *
   * @param {Object} event - The event object containing the new budget value.
   * @param {Object} value - The value object representing the channel or publisher.
   * @param {string} media - The type of media (e.g., 'online', 'print').
   */
  updateBudget(event, value, field, media, parentCampaign = false) {
    const newValue =  Number(event?.target?.value.replace(/[^0-9\.]+/g,""));
    const updateBudgetInArray = (arr) => {
      arr.forEach(channel => {
        if (value?.publisher_name) {
          let publisherTotal = 0;
          channel?.publishers.forEach((publisher, publisherIndex) => {
            if (publisher?.tier_id === value?.tier_id) {
              publisher.budget = newValue;
              publisher.budgetLocal = newValue;
            }

            publisherTotal = publisherTotal + CampaignDetailService.removeCommaAndConvertToNumber(publisher[field]);
            publisherTotal = Math.round(publisherTotal * 100) / 100;

            if ((publisherIndex === channel.publishers.length - 1) &&
                (publisherTotal > Math.round(CampaignDetailService.removeCommaAndConvertToNumber(channel[field]) * 100) / 100)) { // if publishers budget total is greater than the channel budget then update the channel budget
              channel.budget = publisherTotal;
              channel.budgetLocal = publisherTotal;
            }
          });
        } else if (channel?.tier_id === value?.tier_id) {
          channel.budget = newValue;
          channel.budgetLocal = newValue;
        }
      });
    };

    if (parentCampaign) {
      if (media === 'online') {
        const parentCampaignOnlineArr = [...this.state.parentCampaignOnlineArr];
        updateBudgetInArray(parentCampaignOnlineArr);
        this.setState({ parentCampaignOnlineArr }, () => { this.updateSelectChannelButtonAndValidateNetMediaTotal(true) });
      } else if (media === 'print') {
        const parentCampaignPrintArr = [...this.state.parentCampaignPrintArr];
        updateBudgetInArray(parentCampaignPrintArr);
        this.setState({ parentCampaignPrintArr }, () => { this.updateSelectChannelButtonAndValidateNetMediaTotal(true) });
      }
    } else {
      if (media === 'online') {
        const onlineArr = [...this.state.onlineArr];
        updateBudgetInArray(onlineArr);
        this.setState({ onlineArr }, () => { this.updateSelectChannelButtonAndValidateNetMediaTotal() });
      } else if (media === 'print') {
        const printArr = [...this.state.printArr];
        updateBudgetInArray(printArr);
        this.setState({ printArr }, () => { this.updateSelectChannelButtonAndValidateNetMediaTotal() });
      }
    }
  }

  /**
   * Handles the change event for the "Select All" checkbox.
   * Toggles the selection state of all items in the specified media type (online or print)
   * and updates the corresponding state arrays.
   *
   * @param {string} media - The type of media, either 'online' or 'print'.
   * @param {boolean} [parentCampaign=false] - Flag indicating if the operation is for a parent campaign.
   */
  onSelectAllCheckboxChange = (media, parentCampaign = false) => {
    const isOnline = media === 'online';

    let nestedData;
    if (parentCampaign) {
      nestedData = isOnline ? this.state.parentCampaignOnlineArr : this.state.parentCampaignPrintArr;
    } else {
      nestedData = isOnline ? this.state.onlineArr : this.state.printArr;
    }
    
    const tableId = isOnline ? 'online-table' : 'print-table';
    const checkAllKey = isOnline ? 'campaignOnlineTableCheckAll' : 'campaignPrintTableCheckAll';
    const dataCacheKey = isOnline ? 'campaignOnlineFlattendedDataCache' : 'campaignPrintFlattendedDataCache';

    TableUtils[checkAllKey] = TableUtils[checkAllKey] === 'all' ? 'none' : 'all';
    TableUtils[dataCacheKey].clear();
    TableUtils.handleCheckAll(nestedData, tableId);

    if (parentCampaign) {
      if (isOnline) {
        this.setState({ parentCampaignOnlineArr: nestedData }, () => {
          this.updateSelectChannelButtonAndValidateNetMediaTotal(true)
        });
      } else {
        this.setState({ parentCampaignPrintArr: nestedData }, () => {
          this.updateSelectChannelButtonAndValidateNetMediaTotal(true)
        });
      }
    } else {
      if (isOnline) {
        this.setState({ onlineArr: nestedData }, () => {
          this.updateSelectChannelButtonAndValidateNetMediaTotal()
        });
      } else {
        this.setState({ printArr: nestedData }, () => {
          this.updateSelectChannelButtonAndValidateNetMediaTotal()
        });
      }
    }
  }

  /**
   * Handles the change event for row checkboxes in the campaign details table.
   *
   * @param {Object} value - The value object representing the checkbox state.
   * @param {number} parentIdx - The index of the parent row.
   * @param {string} media - The type of media, either 'online' or 'print'.
   * @param {boolean} [parentCampaign=false] - Flag indicating if the checkbox is for a parent campaign.
   */
  onRowCheckboxChange = (value, parentIdx, media, parentCampaign = false) => {
    let nestedData;

    if (parentCampaign) {
      nestedData = media === 'online' ? this.state.parentCampaignOnlineArr : this.state.parentCampaignPrintArr;
    } else {
      nestedData = media === 'online' ? this.state.onlineArr : this.state.printArr;
    }

    value.checked = value.checked === 'all' ? 'none' : 'all';
    const tableId = media === 'online' ? 'campaign-online-table-selectall' : 'campaign-print-table-selectall';
    const tableName = media === 'online' ? 'online-table' : 'print-table';
    TableUtils.traverseNodeForCheckbox(parentIdx, value, nestedData, tableId, tableName);

    if (parentCampaign) {
      if (media === 'online') {
        this.setState({ parentCampaignOnlineArr: nestedData }, () => {
          this.updateSelectChannelButtonAndValidateNetMediaTotal(true)
        });
      } else {
        this.setState({ parentCampaignPrintArr: nestedData }, () => {
          this.updateSelectChannelButtonAndValidateNetMediaTotal(true)
        });
      }
    } else {
      if (media === 'online') {
        this.setState({ onlineArr: nestedData }, () => {
          this.updateSelectChannelButtonAndValidateNetMediaTotal()
        });
      } else {
        this.setState({ printArr: nestedData }, () => {
          this.updateSelectChannelButtonAndValidateNetMediaTotal()
        });
      }
    }
  }


  /**
   * Updates the select channel button state and validates the net media total.
   * 
   * @param {boolean} [parentCampaign=false] - Indicates if the operation is for a parent campaign.
   * 
   * @returns {void}
   * 
   * @description
   * This function performs the following operations:
   * 1. Determines the currency name based on whether the campaign is local and if it's a parent campaign.
   * 2. Sets the budget field to use based on the currency name.
   * 3. Flattens and filters the table data based on the campaign type (parent or not).
   * 4. Calculates the total budget for online and print channels.
   * 5. Checks if the channel budget is less than the sum of its publishers' budgets.
   * 6. Enables or disables the select channel button based on the calculated totals and conditions.
   * 7. Updates the state with the new values for the select channel button and the campaign arrays.
   */
  updateSelectChannelButtonAndValidateNetMediaTotal(parentCampaign = false) {
    //checking islocal true the budget key will use as per isLocal true or false
    let isLocal = this.props?.systemParametersData?.data?.isLocal;
    let currencyName;

    if (parentCampaign) {
      currencyName = isLocal && this.state.parentCampaign.local_currency_name ? this.state.parentCampaign.local_currency_name : 'USD';
    } else {
      currencyName = isLocal && this.state.campaignObj.local_currency_name ? this.state.campaignObj.local_currency_name : 'USD';
    }

    let field = isLocal && currencyName ? 'budgetLocal' : 'budget';
    let tableData;

    if (parentCampaign) {
      tableData = [
        ...TableUtils.flattenData(this.state.parentCampaignOnlineArr),
        ...TableUtils.flattenData(this.state.parentCampaignPrintArr)
      ].filter(val => val?.checked === 'all');
    } else {
      tableData = [
        ...TableUtils.flattenData(this.state.onlineArr),
        ...TableUtils.flattenData(this.state.printArr)
      ].filter(val => val?.checked === 'all');
    }

    let onlineTotal = 0;
    let printTotal = 0;

    let isChannelBudgetLessThanPublishers = false;
    let onlineArr;

    if (parentCampaign) {
      onlineArr = [...this.state.parentCampaignOnlineArr];
    } else {
      onlineArr = [...this.state.onlineArr];
    }

    onlineArr.forEach(channel => {
      let publisherTotal = 0;
      channel.publishers.filter(channel => channel.checked === 'all').forEach((publisher, publisherIndex) => {
        // Math.round(d * 100) / 100 for onlineTotal and publisherTotal to ensure precision
        onlineTotal += CampaignDetailService.removeCommaAndConvertToNumber(publisher[field]);
        publisherTotal += CampaignDetailService.removeCommaAndConvertToNumber(publisher[field]);
        onlineTotal = Math.round(onlineTotal * 100) / 100;
        publisherTotal = Math.round(publisherTotal * 100) / 100;

        if (publisherTotal > Math.round(CampaignDetailService.removeCommaAndConvertToNumber(channel[field]) * 100) / 100) {
          isChannelBudgetLessThanPublishers = true;
          channel['isChannelBudgetLessThanPublishers'] = true;
        } else {
          isChannelBudgetLessThanPublishers = false;
          channel['isChannelBudgetLessThanPublishers'] = false;
        }
      })

    });

    let printArr;

    if (parentCampaign) {
      printArr = [...this.state.parentCampaignPrintArr];
    } else {
      printArr = [...this.state.printArr];
    }

    printArr.forEach(channel => {
      let publisherTotal = 0;
      channel.publishers.filter(channel => channel.checked === 'all').forEach((publisher, publisherIndex) => {
        printTotal += CampaignDetailService.removeCommaAndConvertToNumber(publisher[field]);
        publisherTotal += CampaignDetailService.removeCommaAndConvertToNumber(publisher[field]);
        printTotal = Math.round(printTotal * 100) / 100;
        publisherTotal = Math.round(publisherTotal * 100) / 100;

        if (publisherTotal > Math.round(CampaignDetailService.removeCommaAndConvertToNumber(channel[field]) * 100) / 100) {
          channel['isChannelBudgetLessThanPublishers'] = true;
          isChannelBudgetLessThanPublishers = true;
        } else {
          isChannelBudgetLessThanPublishers = false;
          channel['isChannelBudgetLessThanPublishers'] = false;
        }
      })
    });

    let enableSelectChannelButton;

    if (parentCampaign) {
      enableSelectChannelButton = tableData.length > 0 &&
        !isChannelBudgetLessThanPublishers &&
        this.state.childCampaignStartDate &&
        this.state.childCampaignEndDate;
    } else {
      enableSelectChannelButton = tableData.length > 0 &&
        this.state.totalInOverallBudget?.planningSystemAmount >= (onlineTotal + printTotal) &&
        !isChannelBudgetLessThanPublishers;
    }

    if (parentCampaign) {
      this.setState({ 
        enableSelectChannelButton, parentCampaignOnlineArr: onlineArr, parentCampaignPrintArr: printArr,
        displayChildCampaignTotalErrorMessage: this.state.parentTotalInOverallBudget?.netMedia < (onlineTotal + printTotal)
      });
    } else {
      this.setState({ enableSelectChannelButton, onlineArr, printArr });
    }

  }

  /**
   * Generates the columns configuration for the Media Mix table.
   *
   * @param {string} media - The type of media (e.g., 'online', 'print').
   * @returns {Array<Object>} - The array of column configurations for the Media Mix table.
   */
  getMediaMixColumns(media, parentCampaign = false) {
    let isLocal = this.props?.systemParametersData?.data?.isLocal;
    let currencyName = isLocal && this.state.campaignObj.local_currency_name ? this.state.campaignObj.local_currency_name : 'USD' ;
    
    return [
      {
        label: html`<omni-checkbox
            id="campaign-${media}-table-selectall"
            part="campaign-detail-checkbox"
            ?checked=${media === 'online' ? (TableUtils.campaignOnlineTableCheckAll === 'all') : (TableUtils.campaignPrintTableCheckAll === 'all')}
            ?indeterminate=${media === 'online' ? (TableUtils.campaignOnlineTableCheckAll === 'some') : (TableUtils.campaignPrintTableCheckAll === 'some')}
            @change=${() => this.onSelectAllCheckboxChange(media, parentCampaign)}
            @click=${(event) => { event.stopPropagation() }}
            ></omni-checkbox>
            <span part="margin-left-20" style="font-size: 12px !important">Channel</span>`,
        key: "checked",
        template: (value, index, parentIdx) => {
          if (value.channel_name || value.publisher_name) {
            let channelTemplate;
            if (value?.publisher_name && value?.publisher_type !== "Ad Serving" && value?.publisher_type !== "Ad Verification") {
              channelTemplate = html`
                  <span part="table-child-row margin-left-20 td-content">${value?.displayName}</span>
                `;
            } else {
              channelTemplate = html`
                  <span part="table-channel-name table-body-cell margin-left-20 td-content">${value?.displayName}</span>
                `;
            }

            return html`
              <style>
                :host::part(td-content) {
                  color: var(--color-grey-600) !important;
                }

                :host span {
                  font-size: 14px !important;
                }

                :host::part(th-content){
                  font-size: 12px !important;
                }
                  
                :host::part(margin-left-20){
                  margin-left: 20px !important;
                }

                :host::part(table-channel-name) {
                  padding-left: 0px !important;
                  color: var(--color-grey-900) !important;
                  font-weight: 600 !important;
                }
              </style>
              
              <div part="table-body-cell" id="td-${value.id || (value && value["_hash"])}">
                <omni-checkbox
                  part="campaign-detail-checkbox"
                  id="${value.channel_name ? media + "-" + value.id || (value && value["_hash"]) || value.channel_name + "-" + index : media + "-" + value.publisher_name + "-" + index}"
                  name="${value.id}"
                  ?checked=${value.checked === 'all'}
                  ?indeterminate=${value.checked === 'some'}
                  @change=${() => { this.onRowCheckboxChange(value, parentIdx, media, parentCampaign) }}></omni-checkbox>
              </div>
              ${channelTemplate}`;
          }
        },
        isSortable: true,
        passthrough: true,
      },
      {
        label: "NET MEDIA",
        key: "budget",
        default: "",
        isSortable: true,
        passthrough: true,
        template: (value, index) => {
          let field = isLocal && currencyName ? 'budgetLocal' :'budget';
          let budget = value[field]?.toLocaleString('en-US', { style: "currency", currency: currencyName });
          return (['Ad Verification', 'Ad Serving']).includes(value?.publisher_type) ? html`<td></td>` : this.getTextboxTemplate(value, index, field, media, budget, parentCampaign);
        },
      },
      {
        label: "Fee Amount",
        key: "totalFeeAmount",
        default: "",
        isSortable: true,
        passthrough: true,
        template: (value, index) => {
          let field = isLocal && currencyName ? 'totalFeeAmountLocal' :'totalFeeAmount';
          let budget = value[field]?.toLocaleString('en-US', { style: "currency", currency: currencyName })
          return (['Ad Verification', 'Ad Serving']).includes(value?.publisher_type) ? this.getTextboxTemplate(value, index, field, media, budget, parentCampaign) : html`<td></td>`;
        },
      },
      {
        label: "Fee Type",
        key: "publisher_type",
        default: "",
        isSortable: true,
        passthrough: false,
        template: (value) => {
          const displayValue = value !== 'Supplier' ? value : '';
          return html`<td part="table-body-cell">
              <span>${displayValue}</span></td>`;
        },
      },
      {
        label: "START DATE",
        key: "startDate",
        default: "",
        isSortable: true,
        passthrough: true,
        template: (value, index) => { return this.getDateTemplate(value, index, 'startDate', this.state.campaignObj['startDate'],this.state.campaignObj['endDate'], parentCampaign) }
      },
      {
        label: "END DATE",
        key: "endDate",
        default: "",
        isSortable: true,
        passthrough: true,
        template: (value, index) => { return this.getDateTemplate(value, index, 'endDate', this.state.campaignObj['startDate'],this.state.campaignObj['endDate'], parentCampaign) }
      },
    ];
  };

  /**
   * Generates a date input template for a table cell.
   *
   * @param {Object} value - The object containing the date value.
   * @param {number} index - The index of the current row.
   * @param {string} field - The field name for the date value.
   * @param {string} minDate - The minimum allowable date.
   * @param {string} maxDate - The maximum allowable date.
   * @param {boolean} [parentCampaign=false] - Flag indicating if the date is for a parent campaign.
   * @returns {TemplateResult} The HTML template for the date input field.
   */
  getDateTemplate = (value, index, field, minDate, maxDate, parentCampaign = false) => {
    return html`
    <style>
    input[type="date"]:before {
        content: attr(data-date);
        margin-left: 35px;
        color: black;
    }

    input[type="date"]::-webkit-datetime-edit,
    input[type="date"]::-webkit-inner-spin-button,
    input[type="date"]::-webkit-clear-button {
        display: none;  
    }

    input[type="date"]::-webkit-calendar-picker-indicator {
        position: absolute;
        top: 6px;
        left: 15px;
        width: 18px;
        height: 18px;
        content: 'asdasd';
        color: black;
        opacity: 1;
    }    
    </style>
    <td id=${index + '-date'}>
        <div className="date-field">
            <input
            id=${field + '-date-' + index}
            data-date=${this.getDate(value[field]) || "Enter Date"}
            type="date"
            class="input text"
            min=${minDate}
            max=${maxDate}
            @change=${(event) => { this.updateDateInChildCampaign(value, index, field, event, parentCampaign) }}
            .value=${value[field]}
            />
        </div>
    </td>`
  }

  /**
   * Updates the date in the child campaign for the specified field.
   *
   * @param {Object} value - The value object containing the tier_id and possibly channel_name.
   * @param {number} index - The index of the item to update.
   * @param {string} field - The field to update.
   * @param {Object} event - The event object containing the new value.
   * @param {boolean} [parentCampaign=false] - Flag indicating if the update is for a parent campaign.
   */
  updateDateInChildCampaign(value, index, field, event, parentCampaign = false) {
    let onlineArr;
    let printArr;

    if (parentCampaign) {
      onlineArr = [...this.state.parentCampaignOnlineArr];
      printArr = [...this.state.parentCampaignPrintArr];
    } else {
      onlineArr = [...this.state.onlineArr];
      printArr = [...this.state.printArr];
    }
    
    let newValue = event?.target?.value;

    const updateField = (arr) => {
      for(let i=0;i<arr.length;i++){
        let channel = arr[i];
        if(channel?.tier_id === value?.tier_id){
          channel[field] = newValue;
          break;
        }
        if(channel?.publishers?.length){
          for(let j=0;j<channel?.publishers?.length;j++){
            let publisher = channel?.publishers[j];
            if(publisher?.tier_id === value?.tier_id){
              publisher[field] = newValue;
              break;
            }
          }
        }
      }
    };

    updateField(onlineArr);
    updateField(printArr);

    if (parentCampaign) {
      this.setState({ parentCampaignOnlineArr: onlineArr, parentCampaignPrintArr: printArr }, () => {
        this.updateSelectChannelButtonAndValidateNetMediaTotal(true);
      });
    } else {
      this.setState({ onlineArr, printArr });
    }
  }

  /**
* Creates a payload for a child campaign based on the selected channels and their publishers.
* The payload includes campaign taxonomy, display name, start and end dates, schema, client code, parent ID, and channels.
* The channels include their respective publishers and their details.
* The payload is then set in the state for preview.
*/
  createChildCampaignPreview = () => {
    const channelsList = this.state.onlineArr.filter(item => item?.checked === 'all' || item?.checked === 'some');
    const printChannelsList = this.state.printArr.filter(item => item?.checked === 'all' || item?.checked === 'some');
    channelsList.push(...printChannelsList);
    let channelListForPreview = [];

    let isLocal = this.props?.systemParametersData?.data?.isLocal && this.state.campaignObj.local_currency_name;
    let overBudget = false;
    
    channelsList.forEach((channel, channelIndex) => {
      let channelObj = {};
      channelObj['tier_id'] = '';
      channelObj['channel_name'] = channel['channel_name'];
      channelObj['channel_display_name'] = channel['channel_display_name'];
      channelObj['channel_tier_id'] = channel['channel_tier_id'];
      channelObj['export_status'] = '';
      channelObj['amount_sent'] = '';
      channelObj['amount_sent_local'] = '';
      channelObj['channel_authorized_amount'] = null;
      channelObj['channel_authorized_amount_local'] = null;
      channelObj['channel_enddate'] = channel['endDate'];
      channelObj['channel_fees'] = '';
      channelObj['channel_fees_local'] = '';
      channelObj['channel_plannedctc'] = '';
      channelObj['channel_plannedctc_local'] = '';
      channelObj['channel_startdate'] = channel['startDate'];
      channelObj['channel_total_budget'] = channel['budget'];
      channelObj['channel_total_budget_local'] = channel['budgetLocal'];
      channelObj['channel_total_budget_by_placements'] = 0;
      channelObj['channel_total_budget_by_placements_local'] = 0;
      channelObj['channel_total_budget_in_pmds'] = channel['budget'];
      channelObj['channel_total_budget_in_pmds_local'] = channel['budgetLocal'];
      channelObj['created_at'] = '';
      channelObj['created_by'] = '';
      channelObj['error_description'] = '';
      channelObj['parent_id'] = '';
      channelObj['publishers'] = [];

      const selectedPublishers = channel?.publishers.filter(publisher => publisher?.checked === 'all' || publisher?.checked === 'some');

      selectedPublishers?.length && selectedPublishers.forEach((publisher, publisherIndex) => {
        let publisherObj = {}
        publisherObj['endDate'] = publisher?.endDate;
        publisherObj['parent_id'] = '';
        publisherObj['publisher_authorized_amount'] = '';
        publisherObj['publisher_budget'] = publisher?.budget || publisher?.publisher_budget;
        publisherObj['publisher_budget_local'] = publisher?.budgetLocal || publisher?.publisher_budget_local;
        publisherObj['publisher_name'] = publisher?.publisher_name;
        publisherObj['publisher_display_name'] = publisher?.publisher_display_name;
        publisherObj['publisher_type'] = publisher?.publisher_type;
        publisherObj['tier_id'] = '';
        publisherObj['publisher_start_date'] = publisher?.startDate;
        publisherObj['publisher_end_date'] = publisher?.endDate;
        publisherObj['startDate'] = publisher?.startDate;
        publisherObj['publisher_budget_by_placements'] = 0;
        publisherObj['publisher_budget_by_placements_local'] = 0;
        publisherObj['publisher_budget_in_pmds'] = publisher['budget'];
        publisherObj['publisher_budget_in_pmds_local'] = publisher['budgetLocal'];

        channelObj['publishers'].push(publisherObj)
      })

      channelListForPreview.push(channelObj)

      if(isLocal && channel.budgetLocal > channel.channel_total_budget_in_pmds_local || !isLocal && channel.budget > channel.channel_total_budget_in_pmds){
        overBudget = true;
      }

      if (channelIndex + 1 === channelsList.length) {
        let campaignObjPreview = {...this.state.childCampaignPreview}        
        campaignObjPreview = {
          campaignObj: {
            id: this.state?.campaignObj?.id,
            campaign_taxonomy: this.state.taxonomyName,
            campaign_taxonomy_display: this.state.taxonomyNameWithAbbrevation,
            client_code: this.state.clientCode,
            taxonomy_schema: this.state.taxonomySchema,
            start_date: this.state.startDate ? this.state.startDate : this.state?.campaignObj?.startDate,
            end_date: this.state.endDate ? this.state.endDate : this.state?.campaignObj?.endDate,
            campaign_name: this.props.state?.campaignObj?.campaign_name,
            media_attributes: {
              channels: channelListForPreview,
            },
            local_currency_name: this.props.state?.campaignObj?.local_currency_name,
            campaign_total_budget: this.props.state?.campaignObj?.campaign_total_budget,
            campaign_total_budget_local: this.props.state?.campaignObj?.campaign_total_budget_local,
            taxonomy: this.state?.campaignObj?.taxonomy
          }
        }

        if(overBudget){
          AlertMessagesService.showWarningToastMessage("One or more selected channels exceed their net media budget from the parent planning system amount. Please adjust channel budgets to be equal or less than parent planning system amount.");
        } else {
          this.setState({
            displayChildCampaignPreview: true,
            childCampaignPreview: campaignObjPreview,
          })
        }
      }
    })
  }

  /**
   * Creates a child campaign with the current state data and sends it to the server.
   * The payload includes campaign taxonomy, display name, start and end dates, schema, client code, parent ID, and channels.
   * The channels include their respective publishers and their details.
   */
  createChildCampaign = () => {
    const channelsList = [...this.state.onlineArr, ...this.state.printArr];
    let partners = [];
    let channelListForPayload = channelsList.map(channel => {
      let isLocal = this.props?.systemParametersData?.data?.isLocal;
      let currency = this.props.campaignObj.local_currency_name;
      let budgetField = isLocal && currency ? 'budgetLocal' : 'budget';
      let partner = channel.publishers.map(item=>item.publisher_name);
      if(partner?.length){
        partners.push(...partner);
      }
      return {
        channel_name: channel.channel_name,
        channel_startdate: channel.startDate || null,
        channel_enddate: channel.endDate || null,
        channel_total_budget: channel[budgetField] ? Number(String(channel[budgetField]).replace(/,/g, '')) : 0,
        tier_id: channel.channel_tier_id,
        publishers: channel.publishers.map(publisher => {
          let publisherBudget = isLocal && currency ? (publisher['budgetLocal'] || publisher['publisher_budget_local']) : (publisher['budget'] || publisher['publisher_budget']);
          return {
            publisher_name: publisher.publisher_name,
            publisher_budget: publisherBudget ? Number(String(publisherBudget).replace(/,/g, '')) : 0,
            publisher_type: publisher.publisher_type,
            publisher_start_date: publisher.publisher_start_date || null,
            publisher_end_date: publisher.publisher_end_date || null
          };
        })
      };
    });

    const payload = {
      'campaign_name': this.state.campaignObj?.campaign_name,
      'campaign_taxonomy': this.state.taxonomyName,
      'campaign_taxonomy_display': this.state.taxonomyNameWithAbbrevation,
      'campaign_startdate': this.state?.campaignObj?.startDate,
      'campaign_enddate': this.state?.campaignObj?.endDate,
      'taxonomy_schema': this.state.taxonomySchema,
      'client_code': this.state.clientCode,
      'parent_id': this.state?.campaignObj?.id,
      'channels': channelListForPayload,
      'is_currency_local': this.props?.systemParametersData?.data?.isLocal,
      'parent_campaign_total_budget': this.state?.campaignObj?.campaign_total_budget,
      'parent_campaign_total_budget_local': this.state?.campaignObj?.campaign_total_budget_local,
      'taxonomy': this.state.campaignObj.taxonomy ||this.state.taxonomyJson,
      'taxonomy_client_id': this.props.campaignTaxonomyData?.clientid,
      'taxonomy_schema_id': this.props.campaignTaxonomyData?.id
    }

    CampaignDetailService.createChildCampaign(payload).then(response => {
      trackEvent(`Planned platform campaign is created.`, { access_from: 'Campaign Details Page', campaignId: this.state?.campaignObj?.id });
      const campaignObj = { ...this.state?.campaignObj };
      campaignObj['source'] = response['data']['source'];
      campaignObj['mediaocean_id'] = response['data']['mediaocean_id'];
      campaignObj['id'] = response['data']['id'];
      campaignObj['campaignName'] = this.state.campaignObj?.campaign_name;
      //removeing dublicate value in array
      partners = partners.filter(function(item, pos) {
        return partners.indexOf(item) == pos;
      });
      campaignObj['partners'] = partners;
      this.setState({ campaignObj, isChildCampaignCreated: true,taxonomyJson:null }, () => {
        this.props?.setChildCampaignIsCreated(true);
        AlertMessagesService.showSuccessToastMessage('You have successfully created a new Planned Platform Campaign, which is a sub campaign under the existing campaign shell.');
        // Update the state with new data
        const newState = { ...this.props.location.state, campaignObj: campaignObj };
        // Use navigate to navigate back to campaign table
        this.props.navigate("/");
      })
    }, (error) => {
      trackEvent(`Planned platform campaign is not created.`, { access_from: 'Campaign Details Page', campaignId: this.state?.campaignObj?.id, error: error?.response?.data });
      AlertMessagesService.showErrorToastMessage('Sub campaign is not created please try again.')
    })
  }

  /**
   * Renders the Media Mix accordion component.
   * @param {boolean} [isModal=false] - Indicates if the component is rendered in a modal.
   * @returns {JSX.Element} - The Media Mix accordion component.
   */
  getMediaMixAccordion = (isModal = false) => {
    return (
      <>
        {this.state.onlineArr?.length > 0 &&
          <>
            <div className='accordionHeader'>
              <div className="mediamix-table-header" onClick={() => this.openAccordion('online')}>
                {this.state.displayOnlineAccordionContent === 'none' && (
                  <omni-icon
                    className='is-size-1'
                    icon-id='omni:interactive:up'
                  ></omni-icon>
                )}
                {this.state.displayOnlineAccordionContent === 'block' && (
                  <omni-icon
                    className='is-size-4'
                    icon-id='omni:interactive:down'
                  ></omni-icon>
                )}
                <div>Media Mix (Online)</div>
              </div>
            </div>
            {this.state.displayOnlineAccordionContent === 'none' && (
              isModal ?
                <OmniTableComponent
                  id='online-table'
                  className='table-section-wrapper table-section-wrapper-online'
                  data={this.state.onlineArr}
                  columns={this.getMediaMixColumns('online')}
                  sort={this.state.sort}
                  onSortUpdate={this.onSortUpdate}
                  onExpandOrCollapse={this.onExpandOrCollapse}
                  nestedIndent={20}
                  keyFn={row => row && row._uniqueKey}
                  key={this.state.onlineArr.length}
                  expandAllOnLoad
                />
                :
                <OmniTableStickyComponent
                  stickyside="right"
                  className='table-section-wrapper table-section-wrapper-online'
                  id='online-table'
                  data={this.state.onlineArr}
                  leftColumns={this.getMediaMixLeftColumns('online')}
                  rightColumns={this.getMediaMixRightColumns('online')}
                  sort={this.state.sort}
                  onSortUpdate={this.onSortUpdate}
                  onExpandOrCollapse={this.onExpandOrCollapse}
                  nestedIndent={20}
                  keyFn={row => row && row._uniqueKey}
                  key={this.state.onlineArr.length}
                  expandAllOnLoad
                  stickyscrollbar={true}
                >
                </OmniTableStickyComponent>
            )}
          </>
        }

        {this.state.printArr && this.state.printArr.length > 0 && (
          <>
            <div className='accordionHeader'>
              <div className="mediamix-table-header" onClick={() => this.openAccordion('print')}>
                {this.state.displayPrintAccordionContent === 'none' && (
                  <omni-icon
                    className='is-size-1'
                    icon-id='omni:interactive:up'
                  ></omni-icon>
                )}
                {this.state.displayPrintAccordionContent === 'block' && (
                  <omni-icon
                    className='is-size-4'
                    icon-id='omni:interactive:down'
                  ></omni-icon>
                )}
                <div>Media Mix (Print)</div>
              </div>
            </div>
            {this.state.displayPrintAccordionContent === 'none' && (
              isModal ?
                <OmniTableComponent
                  id='print-table'
                  className='table-section-wrapper table-section-wrapper-print'
                  data={this.state.printArr}
                  columns={this.getMediaMixColumns('print')}
                  sort={this.state.sort}
                  onSortUpdate={this.onSortUpdate}
                  onExpandOrCollapse={this.onExpandOrCollapse}
                  keyFn={row => row && row._uniqueKey}
                  key={this.state.printArr.length}
                  expandAllOnLoad
                />
                :
                <OmniTableStickyComponent
                  stickyside="right"
                  className='table-section-wrapper table-section-wrapper-online'
                  data={this.state.printArr}
                  leftColumns={this.getMediaMixLeftColumns('print')}
                  rightColumns={this.getMediaMixRightColumns('print')}
                  sort={this.state.sort}
                  onSortUpdate={this.onSortUpdate}
                  onExpandOrCollapse={this.onExpandOrCollapse}
                  keyFn={row => row && row._uniqueKey}
                  key={this.state.printArr.length}
                  id='print-table'
                  expandAllOnLoad={true}
                  stickyscrollbar={true}
                >
                </OmniTableStickyComponent>
            )}
          </>
        )}
      </>
    );
  };


  /**
   * Renders the parent campaign media mix accordion component.
   * 
   * This component displays two sections: one for online media mix and one for print media mix.
   * Each section contains an accordion header that toggles the visibility of the corresponding media mix table.
   * 
   * @returns {JSX.Element} The parent campaign media mix accordion component.
   */
  getParentCampaignMediaMixAccordion = () => {
    return (
      <>
        {this.state.parentCampaignOnlineArr?.length > 0 &&
          <>
            <div className='accordionHeader'>
              <div className="mediamix-table-header" onClick={() => this.openAccordion('online')}>
                {this.state.displayOnlineAccordionContent === 'none' && (
                  <omni-icon
                    className='is-size-1'
                    icon-id='omni:interactive:up'
                  ></omni-icon>
                )}
                {this.state.displayOnlineAccordionContent === 'block' && (
                  <omni-icon
                    className='is-size-4'
                    icon-id='omni:interactive:down'
                  ></omni-icon>
                )}
                <div>Media Mix (Online)</div>
              </div>
            </div>
            <OmniTableComponent
              id='online-table'
              className='table-section-wrapper table-section-wrapper-online parent-campaign-table'
              data={this.state.parentCampaignOnlineArr}
              columns={this.getMediaMixColumns('online', true)}
              sort={this.state.sort}
              onSortUpdate={this.onSortUpdate}
              onExpandOrCollapse={this.onExpandOrCollapse}
              nestedIndent={20}
              keyFn={row => row && row._uniqueKey}
              key={this.state.parentCampaignOnlineArr.length}
              expandAllOnLoad
            />
          </>
        }

        {this.state.parentCampaignPrintArr && this.state.parentCampaignPrintArr.length > 0 && (
          <>
            <div className='accordionHeader'>
              <div className="mediamix-table-header" onClick={() => this.openAccordion('print')}>
                {this.state.displayPrintAccordionContent === 'none' && (
                  <omni-icon
                    className='is-size-1'
                    icon-id='omni:interactive:up'
                  ></omni-icon>
                )}
                {this.state.displayPrintAccordionContent === 'block' && (
                  <omni-icon
                    className='is-size-4'
                    icon-id='omni:interactive:down'
                  ></omni-icon>
                )}
                <div>Media Mix (Print)</div>
              </div>
            </div>
            <OmniTableComponent
              id='print-table'
              className='table-section-wrapper table-section-wrapper-print parent-campaign-table'
              data={this.state.parentCampaignPrintArr}
              columns={this.getMediaMixColumns('print', true)}
              sort={this.state.sort}
              onSortUpdate={this.onSortUpdate}
              onExpandOrCollapse={this.onExpandOrCollapse}
              keyFn={row => row && row._uniqueKey}
              key={this.state.parentCampaignPrintArr.length}
              expandAllOnLoad
            />

          </>
        )}
      </>
    );
  };

  /**
 * Sends a child campaign to Media Ocean after user confirmation.
 * Displays a confirmation message to the user and, upon confirmation, calls the sendToMediaOcean method.
 */
  displaySendToMediaOceanConfirmation = () => {
    const confirmMessage = 'This action will create campaign names in Media Ocean for each channel and/or time frame. Once the campaign is sent to Media Ocean, it cannot be reverted back to a consolidated campaign.'
    om2confirm(confirmMessage, {
      callback: () => this.sendToMediaOcean(),
      type: "warning",
      title: `Send campaign confirmation`,
    });
  }

  /**
   * Sends the campaign to Media Ocean.
   * If the campaign source is 'MediaOps' and it does not have a mediaocean_id, it displays a confirmation message.
   * Otherwise, it directly sends the campaign to Media Ocean.
   */
  sendCampaignToMediaOcean = () => {
    if (this.state?.campaignObj?.source === 'MediaOps' && !this.state?.campaignObj?.mediaocean_id) {
      this.displaySendToMediaOceanConfirmation()
    } else {
      this.sendToMediaOcean()
    }
  }

  /**
   * Updates the total in the overall budget and the child campaign preview state.
   *
   * @param {number} totalInOverallBudget - The total amount in the overall budget.
   */
  updateTotalInOverallBudget(totalInOverallBudget) {
    totalInOverallBudget = Utils.transformAmounts(totalInOverallBudget);
    let childCampaignPreview = { ...this.state.childCampaignPreview }
    childCampaignPreview['totalInOverallBudget'] = totalInOverallBudget;
    this.setState({ totalInOverallBudget, childCampaignPreview });
  }

  /**
  * Extracts the campaign name from the given string.
  *
  * @param {string} str - The input string containing the campaign name.
  * @returns {string} - The extracted campaign name.
  */
  getCampaignName(str) {
    const match = str?.match(/Campaign Name : ([^,]+)/);
    return match ? match[1] : '';
  }

  /**
   * Generates an array of taxonomy synchronization data and updates the component state.
   * The array contains objects with taxonomy data and their respective sources.
   * 
   * The function checks if the mediaOceanCampaignTaxonomy and planitCampaignTaxonomy
   * are different from mediaopsCampaignTaxonomy and adds them to the array if they are.
   * 
   * @returns {void}
   */
  generateTaxonomySyncDataArray = () => {
    let taxonomySyncDataArray = [{
      taxonomy: this.state.syncTaxonomiesWithHighlights?.mediaopsCampaignTaxonomy,
      source: 'Media Ops'
    }];

    if (this.state.mediaOceanCampaignTaxonomy && this.state.mediaOceanCampaignTaxonomy !== this.state.mediaopsCampaignTaxonomy) {
      taxonomySyncDataArray.push({
        taxonomy: this.state.syncTaxonomiesWithHighlights?.mediaOceanCampaignTaxonomy,
        source: 'Media Ocean'
      });
    }

    if (this.state.planitCampaignTaxonomy !== this.state.mediaopsCampaignTaxonomy) {
      taxonomySyncDataArray.push({
        taxonomy: this.state.syncTaxonomiesWithHighlights?.planitCampaignTaxonomy,
        source: 'Planit'
      });
    }

    const planitObject = taxonomySyncDataArray.find(item => item.source === 'Planit');
    const otherObjects = taxonomySyncDataArray.filter(item => item.source !== 'Planit');
    if (planitObject) {
      taxonomySyncDataArray = [planitObject, ...otherObjects];
    }
    

    this.setState({ taxonomySyncDataArray })
  }

  /**
   * Generates the MediaOcean campaign taxonomy and updates the state with the generated taxonomy.
   * The taxonomy is derived from the campaign name obtained from the campaign object's error description.
   * After updating the state, it triggers the update of the taxonomy sync error message and highlights.
   *
   * @function
   * @name generateMediaOceanCampaignTaxonomy
   */
  generateMediaOceanCampaignTaxonomy = () => {
    this.setState({
      mediaOceanCampaignTaxonomy: this.getCampaignName(this.state?.campaignObj?.error_description)
      // below comment code is needed for testing with mock data
      // mediaOceanCampaignTaxonomy: 'Essentials SANDBOX_NU_NU_Wellness_Health_NU_2024_NU_NU_001'
    }, () => {
      this.updateTaxonomySyncErrorMessage();
      this.updateSyncTaxonomiesWithHighlights();
    })
  }

  /**
   * Updates the state with synchronized taxonomies and highlights the differences.
   * 
   * This function extracts delimiter values from the campaign taxonomy data fields,
   * creates a unique set of delimiters, and constructs a taxonomy object with the
   * current state values. If `mediaOceanCampaignTaxonomy` exists in the state, it
   * adds it to the taxonomy object. It then sets the state with the highlighted
   * differences using the `Utils.highlightDifferences` method and calls
   * `generateTaxonomySyncDataArray` as a callback.
   * 
   * @method updateSyncTaxonomiesWithHighlights
   */
  updateSyncTaxonomiesWithHighlights() {
    const delimeters = this.props.campaignTaxonomyData.fields.map(field => field.delimiter_value);
    const uniqueDelimeters = [...new Set(delimeters)];
    const taxonomyObj = {
      mediaopsCampaignTaxonomy: this.state.mediaopsCampaignTaxonomy,
      planitCampaignTaxonomy: this.state.planitCampaignTaxonomy
    }

    if (this.state.mediaOceanCampaignTaxonomy) {
      taxonomyObj['mediaOceanCampaignTaxonomy'] = this.state.mediaOceanCampaignTaxonomy;
    }

    this.setState({ syncTaxonomiesWithHighlights: Utils.highlightDifferences(taxonomyObj, uniqueDelimeters, this.props.campaignTaxonomyData.fields) }, () => {
      this.generateTaxonomySyncDataArray();
    });
  }

  /**
   * Opens the Taxonomy Sync Modal by setting the state to display it.
   */
  openTaxonomySyncModal = () => {
    this.setState({ displayTaxonomySyncModal: true });
  }

  /**
   * Hides the taxonomy synchronization modal and clears the selected taxonomy.
   * 
   * This function updates the component's state to hide the modal used for
   * synchronizing taxonomy data and resets the selected taxonomy to an empty string.
   */
  cancelTaxonomySyncModal = () => {
    this.setState({ displayTaxonomySyncModal: false, selectedTaxonomyFromSync: '', popupVisible: false });
  }

  /**
   * Handles the selection of taxonomy from sync and updates the campaign with the selected taxonomy.
   * 
   * This function performs the following steps:
   * 1. Sets the spinner count to 1 to indicate loading.
   * 2. Retrieves the selected taxonomy from sync.
   * 3. Splits the taxonomy schema into an array.
   * 4. Constructs a payload object with the selected taxonomy, display taxonomy, schema, and campaign dates.
   * 5. Calls the updateCampaign function with the constructed payload.
   * 
   * @returns {void}
   */
  keepSelectedTaxonomyFromSync = () => {
    this.props.setSpinnerCount(1);
    const selectedTaxonomyFromSync = this.getSelectedTaxonomyFromSync(this.state.selectedTaxonomyFromSync);
    let schemaArr = this.state.taxonomySchema.split('|');
    let taxonomy = this.state.campaignObj?.taxonomy;
    if (this.state?.selectedTaxonomyFromSync?.source === 'Planit') {
      schemaArr =  this.state.planitCampaignSchema.split('|');
      taxonomy =  this.state.planitTaxonomyJson;
    }
    // Apply text case transformation using utility function
    const transformedTaxonomy = PlacementUtils.transformValueToGivenCase(selectedTaxonomyFromSync, this.props.campaignTaxonomyData?.taxonomyTextcase);
    const transformedTaxonomyDisplay = PlacementUtils.transformValueToGivenCase(this.genrateCampaignTaxonomyDisplayForPayload(selectedTaxonomyFromSync), this.props.campaignTaxonomyData?.taxonomyTextcase);
    
    let payload = {
      campaignTaxonomy: transformedTaxonomy,
      campaignTaxonomyDisplay: transformedTaxonomyDisplay,
      taxonomySchema: schemaArr.join('|'),
      campaignStartDate: this.state.campaignObj?.startDate,
      campaignEndDate: this.state.campaignObj?.endDate,
      taxonomy:taxonomy
    };
    this.updateCampaign(payload, null, '');
  }

  /**
   * Retrieves the selected taxonomy based on the source.
   *
   * @param {Object} selectedTaxonomy - The selected taxonomy object.
   * @param {string} selectedTaxonomy.source - The source of the selected taxonomy.
   * @returns {Object} The corresponding campaign taxonomy based on the source.
   */
  getSelectedTaxonomyFromSync = (selectedTaxonomy) => {
    if (selectedTaxonomy?.source === 'Planit') {
      return this.state.planitCampaignTaxonomy;
    } else {
      return this.state.mediaOceanCampaignTaxonomy;
    }
  }

  /**
   * Extracts the substring before a specified character and updates the original string by removing the character and the substring before it.
   *
   * @param {string} str - The original string to be processed.
   * @param {string} char - The character to search for in the string.
   * @returns {Object} An object containing:
   *   - {string} beforeChar: The substring before the specified character.
   *   - {string} updatedStr: The original string with the substring before the character and the character itself removed.
   */
  getStringBeforeCharacterAndUpdate(str, char) {
    const index = str.indexOf(char);
    if (index !== -1) {
      const beforeChar = str.substring(0, index);
      const updatedStr = str.substring(index + char.length);
      return { beforeChar, updatedStr };
    } else {
      return { beforeChar: str, updatedStr: '' };
    }
  }

  /**
   * Generates a display string for the campaign taxonomy based on the provided taxonomy and campaign taxonomy data.
   *
   * @param {string} taxonomy - The initial taxonomy string to be processed.
   * @returns {string} - The generated display string for the campaign taxonomy.
   */
  genrateCampaignTaxonomyDisplayForPayload(taxonomy) {
    let taxonomyString = taxonomy;
    let taxonomyDisplayName = "";

    this.props.campaignTaxonomyData.fields.forEach((field, index) => {
      let fieldTaxonomy = this.getStringBeforeCharacterAndUpdate(taxonomyString, field.delimiter_value);

      if (fieldTaxonomy.beforeChar !== 'NU') {
        if (field?.field_type === 1) {
          field.fielditems.forEach((fieldItem) => {
            if (fieldItem.code === fieldTaxonomy.beforeChar) {
              taxonomyDisplayName += fieldItem.name + field.delimiter_value;
              taxonomyString = fieldTaxonomy.updatedStr;
            }
          });
        } else if (field?.field_type === 9) {
          taxonomyDisplayName += field.static_field_value + field.delimiter_value;
          taxonomyString = fieldTaxonomy.updatedStr;
        } else {
          taxonomyDisplayName += fieldTaxonomy.beforeChar + field.delimiter_value;
          taxonomyString = fieldTaxonomy.updatedStr;
        }
      } else {
        taxonomyDisplayName += field.delimiter_value;
        taxonomyString = fieldTaxonomy.updatedStr;
      }
    });
    
    const finalDisplayName = taxonomyDisplayName.slice(0, -1);
    
    // Apply text case transformation using utility function
    return PlacementUtils.transformValueToGivenCase(finalDisplayName, this.props.campaignTaxonomyData?.taxonomyTextcase);
  }

  /**
   * Updates the taxonomy synchronization error message based on the current state of campaign taxonomies.
   * 
   * This method checks the synchronization status between three taxonomies: 
   * - mediaopsCampaignTaxonomy
   * - planitCampaignTaxonomy
   * - mediaOceanCampaignTaxonomy
   * 
   * Depending on the comparison results, it sets an appropriate error message indicating which systems are out of sync.
   * If all taxonomies are in sync, it clears the error message.
   * 
   * The error message includes a clickable link that opens a modal for reviewing and syncing changes.
   */
  updateTaxonomySyncErrorMessage = () => {
    if (this.state.mediaOceanCampaignTaxonomy) {
      if (this.state.mediaopsCampaignTaxonomy !== this.state.planitCampaignTaxonomy &&
        this.state.planitCampaignTaxonomy !== this.state.mediaOceanCampaignTaxonomy &&
        this.state.mediaopsCampaignTaxonomy !== this.state.mediaOceanCampaignTaxonomy) {
        this.setState({
          taxonomySyncErrorMessage: (<span className="taxonomy-sync-error-message">The taxonomy is not in sync with planning system (Planit) and buying system (Planit and Media Ocean). To review and sync changes &nbsp;<span className="click-here-link" onClick={this.openTaxonomySyncModal}>Click here</span></span>)
        });
      } else if (this.state.mediaopsCampaignTaxonomy === this.state.planitCampaignTaxonomy &&
        this.state.mediaopsCampaignTaxonomy !== this.state.mediaOceanCampaignTaxonomy) {
        this.setState({
          taxonomySyncErrorMessage: (<span className="taxonomy-sync-error-message">The taxonomy is not in sync with buying system (MediaOcean). To review and sync changes &nbsp;<span className="click-here-link" onClick={this.openTaxonomySyncModal}>Click here</span></span>)
        });
      } else if (this.state.mediaopsCampaignTaxonomy === this.state.mediaOceanCampaignTaxonomy &&
        this.state.mediaopsCampaignTaxonomy !== this.state.planitCampaignTaxonomy) {
        this.setState({
          taxonomySyncErrorMessage: (<span className="taxonomy-sync-error-message">The taxonomy is not in sync with planning system (Planit). To review and sync changes&nbsp;<span className="click-here-link" onClick={this.openTaxonomySyncModal}>Click here</span></span>)
        });
      } else {
        this.setState({ taxonomySyncErrorMessage: '' });
      }
    } else {
      if (this.state.mediaopsCampaignTaxonomy !== this.state.planitCampaignTaxonomy) {
        this.setState({
          taxonomySyncErrorMessage: (<span className="taxonomy-sync-error-message">The taxonomy is not in sync with planning system (Planit). To review and sync changes&nbsp;<span className="click-here-link" onClick={this.openTaxonomySyncModal}>Click here</span></span>)
        });
      } else {
        this.setState({ taxonomySyncErrorMessage: '' });
      }
    }
  }

  /**
   * Handles the change event for a radio button.
   *
   * @param {Object} event - The event object from the radio button change.
   * @param {Object} taxonomyObj - The taxonomy object associated with the selected radio button.
   */
  handleRadioChange = (event, taxonomyObj) => {
    this.setState({ selectedTaxonomyFromSync: taxonomyObj });
  }

  /**
   * Generates a list of HTML elements to display campaign taxonomy names with interactive tooltips and clickable items for taxonomy synchronization.
   * @param {string} taxonomyName - The taxonomy name to be split and processed (e.g., "category:subcategory:value").
   * @returns {Array<LitElement>} An array of Lit HTML templates, each representing a row for a taxonomy field with tooltips and clickable elements.
   */
  getCampaignTaxonomyNameForTaxonomySync(taxonomyName) {
    const taxonomyFields = this.props.campaignTaxonomyData.fields;
    const delimiterValue = taxonomyFields[0]['delimiter_value'];
    const campaignTaxonomy = taxonomyName.split(':|');
    const taxonomyNameArr = campaignTaxonomy[0].split(delimiterValue);
    const mediaopsTaxonomyWithHighlightFlag = this.state.syncTaxonomiesWithHighlights.mediaopsCampaignTaxonomy.filter((_, index) => index % 2 === 0).map(item => item.strings[0]); 

    const rows = taxonomyNameArr.map((item, nameIndex) => {
      const taxonomyField = this.props.campaignTaxonomyData?.fields[nameIndex];
      const title = taxonomyField ? taxonomyField.alias || taxonomyField.name : '';
      const isDisabled = !taxonomyField;
      return html`
      <omni-style part="placementName">
          <div class=${isDisabled ? 'campaign-taxonomy-disable' : 'campaign-taxonomy'} style="padding-top: 5px; padding-bottom: 5px;" key="${nameIndex}-campaign-taxonomy">
            <div part="campaign" style="display: flex; cursor: pointer;">
              <omni-tooltip-next>
                <span slot="invoker" id="campaign=${nameIndex}-campaign-taxonomy" part='campaign-name'
                    class=${mediaopsTaxonomyWithHighlightFlag[nameIndex]?.includes('highlight-difference') ? 'taxonomy-sync-name highlight-difference' : 'taxonomy-sync-name'}>
                  ${taxonomyField?.field_type === 9
                      ? html`<span class="static-field">${item}</span>`
                      : html`<span id="campaign-${nameIndex}-campaign-taxonomy-item" @click=${() => { if (!isDisabled) this.campaignNameClickTaxonomySync(nameIndex, item, taxonomyField, taxonomyField?.delimiter_value); }}>${item}</span>`
                    }
                </span>
                <div slot="content">${title}</div>
              </omni-tooltip-next>
              ${taxonomyNameArr.length - 1 === nameIndex ? '' : taxonomyField?.delimiter_value || ''}
            </div>
          </div>
      </omni-style>
    `;
    });

    return rows;
  }

  /**
   * Handles the click event on a campaign name to trigger taxonomy sync popup.
   *
   * Locates the clicked element in a shadow DOM, calculates its position,
   * prepares dropdown values and selected item, and updates the component state
   * to show a popup for taxonomy selection.
   *
   * @param {number} index - The index of the campaign item in the list.
   * @param {string} name - The name or code of the selected taxonomy item.
   * @param {Object} taxonomyFieldList - The taxonomy field list object containing alias/name and fielditems.
   * @param {string} [taxonomyFieldList.alias] - Optional alias for the taxonomy field.
   * @param {string} [taxonomyFieldList.name] - Name of the taxonomy field.
   * @param {Array<Object>} taxonomyFieldList.fielditems - List of taxonomy field items.
   * @param {string} delimiterValue - The delimiter value used for taxonomy fields.
   *
   * @returns {void}
   */
  campaignNameClickTaxonomySync = (index, name, taxonomyFieldList, delimiterValue) => {
    const fieldName = taxonomyFieldList?.alias || taxonomyFieldList?.name;
    if (!fieldName || !name) return;

    const clickElm = querySelectorDeep('omni-table', 'taxonomy-sync-table')?.shadowRoot?.getElementById(`campaign-${index}-campaign-taxonomy-item`);
    if (!clickElm) return;

    const rect = clickElm.getBoundingClientRect();
    const top = rect.bottom + window.scrollY + 8; // extra space
    const left = rect.left + window.scrollX;

    const ddValues = taxonomyFieldList.fielditems.map(item => ({
      value: item.name,
      id: item.code
    }));

    const selectedItem = taxonomyFieldList.fielditems.find(item => item.code === name);
    const initialValue = selectedItem ? selectedItem.name : name;
    const dropdownValue = selectedItem ? { value: selectedItem.name, id: selectedItem.code } : { value: name, id: name };
    const applyButtonId = `edit-aply-btn-${index}-campaign-Taxonomy`;

    this.setState({
      popupVisible: true,
      popupProps: {
        index,
        fieldName,
        ddValues,
        initialValue,
        dropdownValue,
        applyButtonId,
        delimiterValue,
        taxonomyFieldList
      },
      popupPosition: { top, left }
    });
  };

  /**
 * Renders a table cell for taxonomy sync with either inline editing for Media Ops sources or radio buttons for other sources.
 * @param {Object} value - The taxonomy value object containing source and taxonomy information.
 * @param {number} index - The index of the row in the taxonomy sync table.
 * @returns {LitElement} A Lit HTML template for the table cell, either with inline taxonomy editing or radio button selection.
 */
  getTaxonomyWithInlineEditForTaxonomySync = (value, index) => {
        if (value?.source === 'Media Ops') {
          return html`<td style="padding-left: 69px;">
            <div part="td-content" style="display: flex;"> ${this.getCampaignTaxonomyNameForTaxonomySync(this.state.taxonomyName)}</div>
          </td>`
        } else {
          return html`
              <td> 
                <div part="taxonomy-sync-input-container" class="taxonomy-sync-name">
                  <input type="radio" 
                    class="taxonomy-sync-radio-input" 
                    part="taxonomy-sync-radio-input"
                    name="taxonomy" 
                    value=${value?.taxonomy} 
                    id=${value?.taxonomy + index}
                    @change=${(event) => this.handleRadioChange(event, value)}>
                  <label for=${value?.taxonomy + index}>${value?.taxonomy}</label>
                </div>
              </td>`
        }
  }

  getTaxonomySyncModalColumns = [
    {
      label: "CAMPAIGN TAXONOMY",
      key: "taxonomy",
      default: "",
      isSortable: false,
      passthrough: true,
      template: (value, index) => { return this.getTaxonomyWithInlineEditForTaxonomySync(value, index) },
    },
    {
      label: "SOURCE",
      key: "source",
      default: "",
      isSortable: false,
      passthrough: true,
      template: (value, index) => {
        return html`
            <style>
              .edit-popup {
                min-width: 12rem;
                border-radius: 10px;
                padding-top: 4px;
                position: absolute;
                z-index: 20;
                display: none;
              }
              .edit-popup-active {
                display: block;
              }
              :host::part(td-content) {
                color: var(--color-grey-600) !important;
              }
              :host::part(taxonomy-sync-radio-input) {
                width: 18px !important;
                height: 18px !important;
                margin-right: 14px !important;
              } 
              :host::part(taxonomy-sync-input-container) {
                display: flex;
                align-items: center;
              }           
              .highlight-difference {
                color: var(--Legacy-Notification-color-error, #DF5678) !important;
              }         
              .taxonomy-sync-name {
                overflow: hidden;
                color: var(--legacy-core-color-core-dark-100, #3B3E3F);
                text-overflow: ellipsis;
                white-space: nowrap;
                font-family: "Open Sans" !important;
                font-size: 14px !important;
                font-style: normal !important;
                font-weight: 600 !important;
                line-height: 14px !important;
                letter-spacing: 0.043px !important;
              }
            </style>
            <td>
              <span part="td-content">${(this.state?.campaignObj?.data_source === 'Mediaocean' && value?.source === 'Media Ops') ? 'Media Ocean' : value?.source}</span>
            </td>`
      },
    }
  ]

  /**
   * Renders the Taxonomy Sync Table component.
   *
   * @returns {JSX.Element} The rendered OmniTableComponent with taxonomy sync data.
   */
  getTaxonomySyncTable = () => {
    return (
      <>
        <OmniTableComponent
          id='taxonomy-sync-table'
          className='table-section-wrapper table-section-wrapper-online'
          data={this.state.taxonomySyncDataArray}
          columns={this.getTaxonomySyncModalColumns}
          keyFn={row => row && row._uniqueKey}
          key={this.state.taxonomySyncDataArray.length} />
      </>
    )
  }

  /**
   * Gets the data for editing a campaign.
   * @returns {Object} - The campaign edit data.
  */
  getCampaignEditData = () => {
    let taxonomySchemaArray = this.props.campaignTaxonomyData;
    let campaign = this.state.campaignObj;
    let taxonomyJson = campaign?.taxonomy ? campaign?.taxonomy : null;
    let campaignTaxonomy = campaign.campaign_taxonomy.split(':|');
    let taxonomyName = campaignTaxonomy[0];
    let taxonomySchema = campaign?.taxonomy_schema ? campaign?.taxonomy_schema : null;
    let taxonomyData = taxonomySchemaArray?.fields;
    
    return PlacementDetailsTableService.splitPlacementStringIntoSchemaObject(taxonomyName, taxonomySchema, taxonomyData, '', null, taxonomyJson);
  }
  
  /**
   * Renders the Taxonomy Sync Table component.
   * @returns {JSX.Element} The rendered OmniTableComponent with taxonomy sync data.
   */
  onClickCampaignName = () => {
    if(this.state?.taxonomyName){
      let campaign = this.state.campaignObj;
      let campaignTaxonomy = campaign.campaign_taxonomy.split(':|');
      let taxonomyJson = campaign?.taxonomy ? campaign?.taxonomy : null;
      let taxonomySchema = '';
      let taxonomySchemaArray = this.props.campaignTaxonomyData;
      let taxonomyData = taxonomySchemaArray?.fields;
      //if campaign is too old and there is taxonomy_ids_schema
      if(!taxonomyJson?.length && campaign?.taxonomy_ids_schema){
          let taxonomyIds = campaign?.taxonomy_ids_schema.split('|').map(val=> {
              return val.split(' *')[1]
          });
      
          let newSchema = [];
          taxonomyIds.forEach((id,index) => { 
              let field = {};
              field = taxonomyData.find(field=> id == field.id)
              let name = field?.name || field?.alias;
              newSchema.push(name);
          });

          taxonomySchema = newSchema.join('|');
          campaign.taxonomy_schema = taxonomySchema;
      }
      let editFormData = this.getCampaignEditData();
      let isNameAndSchemaFieldMatch = PlacementDetailsTableService.compareTaxonomyAndData(this.props.campaignTaxonomyData?.fields, editFormData, campaign?.taxonomy_schema, taxonomyJson);
      if(!isNameAndSchemaFieldMatch){
        this.isInlineOverride = true;
      }
      campaign.syntheticId = campaign?.synthetic_id;
      const taxonomyKeys = {
          'schema' : 'taxonomy_schema', 
          'displayName' : 'campaign_taxonomy_display', 
          'taxonomyName' : 'campaign_taxonomy', 
          'syntheticId' : campaignTaxonomy[1], 
      }
      this.setState({ isShowModal: true, editableData: campaign, editFormData, taxonomySchemaArray: this.props.campaignTaxonomyData, taxonomyKeys });
    }
  }

  /**
   * Closes the modal for editing creative names.
   * @function closeModal
   */
  closeModal = (payload) => {
    this.setState({ isShowModal: false, editableData: {} });
    this.isInlineOverride = false;
    if(payload){
      if (!this.state?.isCreateChildCampaign && !this.props.displayPreview) {
        this.updateCampaignAfterReesponse(payload)
      } else {
        let campaignObj = { ...this.state.campaignObj };
        campaignObj.campaignTaxonomy = payload.campaign_taxonomy;
        campaignObj.campaign_taxonomy = payload.campaign_taxonomy;
        campaignObj.campaign_taxonomy_display = payload.campaign_taxonomy_display;
        campaignObj.taxonomy = payload?.taxonomy;
        let taxonomyJson = campaignObj?.taxonomy ?  campaignObj?.taxonomy : null;
        this.setState({
          taxonomyName: campaignObj?.campaign_taxonomy?.split(':|')[0],
          taxonomyNameWithAbbrevation: campaignObj['campaign_taxonomy_display'],
          taxonomySchema: campaignObj['taxonomy_schema'],
          campaignObj, spinnerCount: 0,
          selectedDDValue: { name: '', value: null },
          popupVisible: false,
          taxonomyJson
        });
      }
    }
  }

  render() {
    const { popupVisible, popupProps, selectedDDValue } = this.state;

    return (
      <div className="campaign-detail-container">
        <div style={{position: 'absolute', top: '0px'}}>
          <LoaderComponent  spinnerCount={this.state.spinnerCount} displayWholePage={true} />
        </div>
        {!this.state.displayChildCampaignPreview && <>
          {((this.state?.campaignObj?.id === decodeURIComponent(this.props?.params?.campaignId)) || this.props?.displayPreview) && <>
            <div className="sectionWrapper">
              <div className="campaign-detail-section">
                  <div>
                    <div className="campaign-detail-header-container">
                    {(this.state.isCreateChildCampaign || this.props?.displayPreview || this.state?.campaignObj?.parent_id) ? 
                        <span className="Campaign-Details-Header">Planned Platform Campaign</span> :
                        <span className="Campaign-Details-Header">Campaign Shell</span>}

                      {!this.state.isCreateChildCampaign && 
                      !this.props?.displayPreview && 
                      !this.state?.campaignObj?.parent_id &&
                      (this.state?.campaignObj?.data_source?.toLowerCase() !== "mediaocean") && (
                      this.state?.campaignObj?.synthetic_id ? 
                      <button className="medium secondary" onClick={() => this.navigateToPath('campaignDetails/createChildCampaign')}>
                        <OmniIconComponent icon-id="omni:interactive:add"></OmniIconComponent>
                        Create Planned Platform Campaign
                      </button> :
                      <OmniTooltipNextComponent>
                        <div slot="content">Campaign has no Synthetic ID, Please select/change Client Code to assign one</div> 
                        <button slot="invoker" className="medium secondary" disabled={!this.state?.campaignObj?.synthetic_id}>
                          Create Planned Platform Campaign
                        </button>
                      </OmniTooltipNextComponent>)}
                    </div>
                    <div className="campaign-taxonomy-input-container">
                      <div className="label-container">
                        {(this.state.isCreateChildCampaign || this.props?.displayPreview || this.state?.campaignObj?.parent_id) ? <label htmlFor="campaignName" className="cmapaign-label">Planned Platform Campaign Taxonomy</label> : <label htmlFor="campaignName" className="cmapaign-label">Campaign Shell Taxonomy</label>}
                        <div className="synthetic-id-status-container">
                          <label className="synthetic-id-label">Synthetic ID</label>
                          {/* commented below to remove the taxonomy status label as it is not needed */}
                          {/* <label className="taxonomy-status-label">Taxonomy Status</label> */}
                        </div>
                      </div>
                      <div id="campaign-taxonomy-input" className="campaign-taxonomy-input">
                        {this.state.taxonomyName && <div className="campaign-taxonomy-name" >
                          <div className="campaign-taxonomy-input-box" onClick={() => this.onClickCampaignName()}>
                            {this.state.taxonomyName}
                          </div>
                          </div>}
                        <div className="synthetic-id">
                          {!this.state.isCreateChildCampaign && this.state.syntheticId}
                        </div>
                        {/* commented below to remove the taxonomy status label as it is not needed */}
                        {/* <div className="synthetic-id taxonomy-status">
                          {this.state.taxonomySyncErrorMessage ? <span className="taxonomy-error">Taxonomy Error</span> : <span className="taxonomy-success">Taxonomy Match</span>}
                        </div> */}
                      </div>
    
                      {this.state?.campaignObj?.synthetic_id 
                      ? <div className="taxonomy-sync-error-message">{this.state.taxonomySyncErrorMessage}</div>
                      : <></>}
    
                    </div>
                    {this.getCampaignDetailsSection()}
                  </div>

                  <div className="separater"></div>
                  {!this.state.isCreateChildCampaign && (<>
                    <OverAllBudgetComponent onlineArr={this.state?.onlineArr} printArr={this.state?.printArr} updateTotalInOverallBudget={this.updateTotalInOverallBudget } isLocal={this.props?.systemParametersData?.data?.isLocal} currencyName={this.state?.campaignObj?.local_currency_name || this.props?.campaignObj?.local_currency_name}/>
                    <div>
                      {(this.state.onlineArr?.length || this.state.printArr?.length) && (
                        this.getMediaMixAccordion()
                      )}</div>
                  </>)}
              </div>
            </div>
            {this.state.isCreateChildCampaign ?
              <div className="actionButtons">
                <button className="large" disabled={true}>
                  Send to Media Ocean
                </button>
                <button className="large secondary" disabled={true}>
                  Create
                </button>
                <button className="cancel large tertiary" onClick={this.gotoCampaignTable}>
                  Cancel
                </button>
              </div>
              :
              <div className="actionButtons">
                {!this.props?.displayPreview ?
                  <>
                    <button className="large" onClick={() => this.sendCampaignToMediaOcean()} disabled={!this.state.channelsData.filter(d => d.checked).length}>
                      Send to Media Ocean
                    </button>
                    <button className="large secondary" onClick={() => this.needsUpdate()}>
                      {this.state.needsUpdateBtnText}
                    </button>
                  </>
                  :
                  <>
                    <button className="large" onClick={() => this.sendCampaignToMediaOcean()} disabled={!this.state.isChildCampaignCreated || !this.state.channelsData.filter(d => d.checked).length}>
                      Send to Media Ocean
                    </button>
                    {!this.state.isChildCampaignCreated && <button className="large secondary" onClick={() => this.createChildCampaign()}>
                      Create
                    </button>}
                  </>
                }
                <button className="large tertiary" onClick={this.gotoCampaignTable}>
                  Cancel
                </button>
              </div>
            }
          </>}
          {(this.state.isCreateChildCampaign || this.state?.campaignObj?.parent_id) &&
            <ChildCampaignModal
              isChildCampaignModalOpen={this.state.isChildCampaignModalOpen}
              onModalClose={this.handleChildCampaignModalClose}
              getMediaMixAccordion={this.getMediaMixAccordion}
              createChildCampaignPreview={this.createChildCampaignPreview}
              enableSelectChannelButton = {this.state.enableSelectChannelButton}
              editChildCampaign = {this.state.editChildCampaign}
              saveChildCampaignChanges = {this.saveChildCampaignChanges}
              getParentCampaignMediaMixAccordion = {this.getParentCampaignMediaMixAccordion}
              parentCampaign = {this.state.parentCampaign}
              handleChildCampaignDates = {this.handleChildCampaignDates}
              getDate = {this.getDate}
              childCampaignStartDate = {this.state.childCampaignStartDate}
              childCampaignEndDate = {this.state.childCampaignEndDate}
              displayChildCampaignTotalErrorMessage = {this.state.displayChildCampaignTotalErrorMessage}
            />}

          {this.state.displayTaxonomySyncModal &&
            <TaxonomySyncModal
              cancelTaxonomySyncModal={this.cancelTaxonomySyncModal}
              getTaxonomySyncTable={this.getTaxonomySyncTable}
              selectedTaxonomyFromSync={this.state.selectedTaxonomyFromSync}
              keepSelectedTaxonomyFromSync={this.keepSelectedTaxonomyFromSync}
              mediaOceanCampaignTaxonomy={this.state.mediaOceanCampaignTaxonomy}
              mediaopsCampaignTaxonomy={this.state.mediaopsCampaignTaxonomy}
              planitCampaignTaxonomy={this.state.planitCampaignTaxonomy}
            >
            </TaxonomySyncModal>}
        </>}

        {this.state.displayChildCampaignPreview &&
          <CampaignDetailComponent
            campaignTaxonomyData={this.props.campaignTaxonomyData}
            navigate={this.props.navigate}
            location={this.props.location}
            versionOneApi={this.props.versionOneApi}
            displayPreview={true}
            setChildCampaignIsCreated={this.props.setChildCampaignIsCreated}
            setCampaignName={this.props.setCampaignName}
            setSpinnerCount={this.props.setSpinnerCount}
            omniProfile={this.props.omniProfile}
            setCampaignTableData={this.props.setCampaignTableData}
            state={this.state.childCampaignPreview}
            systemParametersData={this.props?.systemParametersData}
            campaignObj= {this.props?.state?.campaignObj}
          ></CampaignDetailComponent>
        }

        {popupVisible && popupProps && (
          <CampaignTaxonomySyncPopup
            {...popupProps}
            {...this.state.popupPosition}
            selectedDDValue={this.state.selectedDDValue}
            onInputChange={this.onCampaignInputChange}
            onDropdownChange={this.onCampaignDropDownChange}
            onCancel={() => this.setState({ popupVisible: false })}
            onApply={() =>
              this.onApplyBtnClickForCampaignNameChange(
                popupProps.index,
                popupProps.applyButtonId,
                popupProps.delimiterValue
              )
            }
          />
        )}
        {/* Inline Edit Dialog */}
        {this.state.isShowModal && this.state?.editableData && <InlineEditDialogBox
            selectedRowData={this.state.editableData}
            onInlineModalClose={this.closeModal}
            displayInlineEditModal ={this.state.isShowModal} 
            editFormData = {this.state?.editFormData}
            isOverride = { this.isInlineOverride }
            taxonomySchemaArray = {this.state?.taxonomySchemaArray}
            taxonomyMap ={null} 
            allTaxonomyData = {null}
            systemParametersData = {this.props.systemParametersData}
            campaignObj = {this.state.campaignObj}
            omniProfile = {this.props.omniProfile}
            versionOneApi = {this.props?.versionOneApi}
            setSpinnerCount={this.props.setSpinnerCount}                         
            taxonomyKeys={this.state.taxonomyKeys}                         
            isCreatingChildCampaign={this.state.isCreateChildCampaign || this.props?.displayPreview}                         
        /> }
        {this.state.showOverBudgetModal &&
          <omni-modal id="over-budget-modal">
            <span slot="header" className="modal-header">Budget Validation Warning</span>
            <div className="modal-body">One or more selected channels exceed their MOH total amount from the planning system amount. Do you want to proceed with sending to MediaOcean?</div>
            <div slot="footer" className="modal-footer">
              <button className="tertiary" onClick={this.closeOverBudgetModal}>Cancel</button>
              <button onClick={this.setPayloadAndCallSendMOApi}>Confirm</button>
            </div>
          </omni-modal>
        } 
      </div>
    );
  }
}
